"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5851,6102,4742],{

/***/ 98284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12102);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52737);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67235);
/* harmony import */ var constants_verifyAppVersion_verifyAppVersionList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58432);





/**
 * 앱 버전에 따라 특정 기능의 노출 여부를 판단하는 범용 훅입니다.
 *
 * 특정 버전 이상일 경우에만 관련 영역이 노출될 수 있도록 Boolean값을 반환하며,
 * 웹뷰가 아닐 경우 무조건 true를 반환합니다.
 *
 * @param versionKey - 확인할 버전 키
 * - 'CAREER_NAVER_LICENSE': 네이버 자격증 연동
 * - 'COVER_LETTER_AD_EDUCATION': 자만검 배너 및 공고 상세 추천 교육
 * - 'SCRAP_USER_STATISTICS': 공고 상세 관심 유저 통계
 * - 'TEAM_RECRUIT': 팀원 모집
 * - 'COMPANY_INFO': 기업정보 더보기
 * @returns {boolean} 기능 노출 여부
 */ var useShowComponentByAppVersion = function(versionKey) {
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), 1), cookies = ref[0];
    var verifyAppVersionRequirement = (0,context__WEBPACK_IMPORTED_MODULE_0__/* .useWebview */ .sW)({
        appVersion: cookies === null || cookies === void 0 ? void 0 : cookies.appVersion
    }).verifyAppVersionRequirement;
    var isComponentVisible = isWebview ? verifyAppVersionRequirement({
        ios: constants_verifyAppVersion_verifyAppVersionList__WEBPACK_IMPORTED_MODULE_2__/* .IOS_APP_VERSIONS */ .ZQ[versionKey],
        aos: constants_verifyAppVersion_verifyAppVersionList__WEBPACK_IMPORTED_MODULE_2__/* .AOS_APP_VERSIONS */ .hk[versionKey]
    }) : true;
    return isComponentVisible;
};
/* harmony default export */ __webpack_exports__["Z"] = (useShowComponentByAppVersion);


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ PC_AD_CODE; },
/* harmony export */   "Q7": function() { return /* binding */ AD_CODE_ID; },
/* harmony export */   "s6": function() { return /* binding */ ACTIVITY_NOTICE_AD_CODE_ID; },
/* harmony export */   "xB": function() { return /* binding */ EDUCATION_RECOMMENDATION_AD_CODE_ID; }
/* harmony export */ });
/* unused harmony exports MOBILE_AD_CODE, ACTIVITY_NOTICE_AD_CODE */
var PC_AD_CODE;
(function(PC_AD_CODE) {
    PC_AD_CODE["MAIN"] = "pc-main-list-banner";
    PC_AD_CODE["HOTLINE"] = "pc-hotline-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_S"] = "pc-recommend-activity-s-banner";
    PC_AD_CODE["RECOMMEND_ACTIVITY_A"] = "pc-recommend-activity-a-banner";
    PC_AD_CODE["WEEKLY_POPULAR"] = "pc-weekly-popular-activity";
    PC_AD_CODE["RECRUIT"] = "pc-recruit-banner";
    PC_AD_CODE["RIGHT_SIDEBAR"] = "pc-right-sidebar-all-of-page";
    PC_AD_CODE["HORIZONTAL"] = "web-activity-horizontal-ad";
    PC_AD_CODE["RECRUIT_QNA_BOTTOM"] = "pc-recruit-qna-bottom";
    PC_AD_CODE["COVER_LETTER_SEARCH"] = "pc-coverletter-search-banner";
    PC_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    PC_AD_CODE["FULLSCREEN_POPUP"] = "pc-full-popup";
    PC_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "pc-education-top-pinned-banner";
})(PC_AD_CODE || (PC_AD_CODE = {}));
var MOBILE_AD_CODE;
(function(MOBILE_AD_CODE) {
    MOBILE_AD_CODE["MAIN"] = "mobile-main-list-banner";
    MOBILE_AD_CODE["HOTLINE"] = "mobile-hotline-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_S"] = "mobile-recommend-activity-s-banner";
    MOBILE_AD_CODE["RECOMMEND_ACTIVITY_A"] = "mobile-recommend-activity-a-banner";
    MOBILE_AD_CODE["WEEKLY_POPULAR"] = "mobile-weekly-popular-activity";
    MOBILE_AD_CODE["RECRUIT"] = "mobile-recruit-banner";
    MOBILE_AD_CODE["RECRUIT_QNA_BOTTOM"] = "mobile-recruit-qna-bottom";
    MOBILE_AD_CODE["COVER_LETTER_SEARCH"] = "mobile-coverletter-search-banner";
    MOBILE_AD_CODE["LIVE_ACTIVITY"] = "live-activity";
    MOBILE_AD_CODE["FULLSCREEN_POPUP"] = "mobile-full-popup";
    MOBILE_AD_CODE["EDUCATION_TOP_PINNED_BANNER"] = "mobile-education-top-pinned-banner";
})(MOBILE_AD_CODE || (MOBILE_AD_CODE = {}));
var AD_CODE_ID = {
    MAIN: {
        PC: PC_AD_CODE.MAIN,
        MOBILE: MOBILE_AD_CODE.MAIN
    },
    HOTLINE: {
        PC: PC_AD_CODE.HOTLINE,
        MOBILE: MOBILE_AD_CODE.HOTLINE
    },
    RECOMMEND_ACTIVITY_S: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_S,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_S
    },
    RECOMMEND_ACTIVITY_A: {
        PC: PC_AD_CODE.RECOMMEND_ACTIVITY_A,
        MOBILE: MOBILE_AD_CODE.RECOMMEND_ACTIVITY_A
    },
    LIVE_ACTIVITY: {
        PC: PC_AD_CODE.LIVE_ACTIVITY,
        MOBILE: MOBILE_AD_CODE.LIVE_ACTIVITY
    },
    WEEKLY_POPULAR: {
        PC: PC_AD_CODE.WEEKLY_POPULAR,
        MOBILE: MOBILE_AD_CODE.WEEKLY_POPULAR
    },
    RECRUIT: {
        PC: PC_AD_CODE.RECRUIT,
        MOBILE: MOBILE_AD_CODE.RECRUIT
    },
    RIGHT_SIDEBAR: {
        PC: PC_AD_CODE.RIGHT_SIDEBAR
    },
    HORIZONTAL: {
        PC: PC_AD_CODE.HORIZONTAL
    },
    RECRUIT_QNA_BOTTOM: {
        PC: PC_AD_CODE.RECRUIT_QNA_BOTTOM,
        MOBILE: MOBILE_AD_CODE.RECRUIT_QNA_BOTTOM
    },
    COVER_LETTER_SEARCH: {
        PC: PC_AD_CODE.COVER_LETTER_SEARCH,
        MOBILE: MOBILE_AD_CODE.COVER_LETTER_SEARCH
    },
    FULLSCREEN_POPUP: {
        PC: PC_AD_CODE.FULLSCREEN_POPUP,
        MOBILE: MOBILE_AD_CODE.FULLSCREEN_POPUP
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: PC_AD_CODE.EDUCATION_TOP_PINNED_BANNER,
        MOBILE: MOBILE_AD_CODE.EDUCATION_TOP_PINNED_BANNER
    }
};
var ACTIVITY_NOTICE_AD_CODE;
(function(ACTIVITY_NOTICE_AD_CODE) {
    ACTIVITY_NOTICE_AD_CODE["INTERN_NOTICE"] = "activity-intern-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["RECRUIT_NOTICE"] = "activity-recruit-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["ACTIVITY_NOTICE"] = "activity-activity-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["CONTEST_NOTICE"] = "activity-contest-notice-banner";
    ACTIVITY_NOTICE_AD_CODE["EDUCATION_NOTICE"] = "activity-education-notice-banner";
})(ACTIVITY_NOTICE_AD_CODE || (ACTIVITY_NOTICE_AD_CODE = {}));
var ACTIVITY_NOTICE_AD_CODE_ID = {
    INTERN_NOTICE: ACTIVITY_NOTICE_AD_CODE.INTERN_NOTICE,
    RECRUIT_NOTICE: ACTIVITY_NOTICE_AD_CODE.RECRUIT_NOTICE,
    ACTIVITY_NOTICE: ACTIVITY_NOTICE_AD_CODE.ACTIVITY_NOTICE,
    CONTEST_NOTICE: ACTIVITY_NOTICE_AD_CODE.CONTEST_NOTICE,
    EDUCATION_NOTICE: ACTIVITY_NOTICE_AD_CODE.EDUCATION_NOTICE
};
var EDUCATION_RECOMMENDATION_AD_CODE_ID = {
    PC: "pc-education-random-banner",
    MOBILE: "mobile-education-random-banner"
};


/***/ }),

/***/ 80979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ACTIVITY_GTM_EVENT; },
/* harmony export */   "c": function() { return /* binding */ GTM_EVENT; }
/* harmony export */ });
/**
 * 광고 영역별 GTM 이벤트 정의
 */ var GTM_EVENT = {
    MAIN: {
        PC: {
            CLICK_EVENT: "pc_main_list_bnr_clk",
            IMPRESSION_EVENT: "pc_main_list_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_main_list_bnr_clk",
            IMPRESSION_EVENT: "mo_main_list_bnr_imp"
        }
    },
    HOTLINE: {
        PC: {
            CLICK_EVENT: "pc_hotline_bnr_clk",
            IMPRESSION_EVENT: "pc_hotline_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_hotline_bnr_clk",
            IMPRESSION_EVENT: "mo_hotline_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_S: {
        PC: {
            CLICK_EVENT: "pc_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_s_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_s_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_s_bnr_imp"
        }
    },
    RECOMMEND_ACTIVITY_A: {
        PC: {
            CLICK_EVENT: "pc_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_act_a_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_act_a_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_act_a_bnr_imp"
        }
    },
    WEEKLY_POPULAR: {
        PC: {
            CLICK_EVENT: "pc_wkly_pop_act_clk",
            IMPRESSION_EVENT: "pc_wkly_pop_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_wkly_pop_act_clk",
            IMPRESSION_EVENT: "mo_wkly_pop_act_imp"
        }
    },
    RECRUIT: {
        PC: {
            CLICK_EVENT: "pc_rec_bnr_clk",
            IMPRESSION_EVENT: "pc_rec_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_bnr_clk",
            IMPRESSION_EVENT: "mo_rec_bnr_imp"
        }
    },
    RIGHT_SIDEBAR: {
        PC: {
            CLICK_EVENT: "pc_rgt_side_all_pg_clk",
            IMPRESSION_EVENT: "pc_rgt_side_all_pg_imp"
        }
    },
    HORIZONTAL: {
        PC: {
            CLICK_EVENT: "pc_horz_ad_clk",
            IMPRESSION_EVENT: "pc_horz_ad_imp"
        }
    },
    RECRUIT_QNA_BOTTOM: {
        PC: {
            CLICK_EVENT: "pc_rec_qna_btm_clk",
            IMPRESSION_EVENT: "pc_rec_qna_btm_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_rec_qna_btm_clk",
            IMPRESSION_EVENT: "mo_rec_qna_btm_imp"
        },
        APP: {
            CLICK_EVENT: "app_rec_qna_btm_clk",
            IMPRESSION_EVENT: "app_rec_qna_btm_imp"
        }
    },
    COVER_LETTER_SEARCH: {
        PC: {
            CLICK_EVENT: "pc_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "pc_cvlt_srch_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "mo_cvlt_srch_bnr_imp"
        },
        APP: {
            CLICK_EVENT: "app_cvlt_srch_bnr_clk",
            IMPRESSION_EVENT: "app_cvlt_srch_bnr_imp"
        }
    },
    LIVE_ACTIVITY: {
        PC: {
            CLICK_EVENT: "pc_live_act_clk",
            IMPRESSION_EVENT: "pc_live_act_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_live_act_clk",
            IMPRESSION_EVENT: "mo_live_act_imp"
        }
    },
    FULLSCREEN_POPUP: {
        PC: {
            CLICK_EVENT: "pc_full_pop_clk",
            IMPRESSION_EVENT: "pc_full_pop_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_full_pop_clk",
            IMPRESSION_EVENT: "mo_full_pop_imp"
        }
    },
    EDUCATION_TOP_PINNED_BANNER: {
        PC: {
            CLICK_EVENT: "pc_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "pc_edu_top_pinned_bnr_imp"
        },
        MOBILE: {
            CLICK_EVENT: "mo_edu_top_pinned_bnr_clk",
            IMPRESSION_EVENT: "mo_edu_top_pinned_bnr_imp"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_top_pinned_bnr_imp",
            CLICK_EVENT: "app_edu_top_pinned_bnr_clk"
        }
    }
};
var ACTIVITY_GTM_EVENT = {
    INTERN_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_int_ntc_bnr_imp",
            CLICK_EVENT: "pc_int_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_int_ntc_bnr_imp",
            CLICK_EVENT: "mo_int_ntc_bnr_clk"
        }
    },
    RECRUIT_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_rec_ntc_bnr_imp",
            CLICK_EVENT: "pc_rec_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_rec_ntc_bnr_imp",
            CLICK_EVENT: "mo_rec_ntc_bnr_clk"
        }
    },
    ACTIVITY_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_act_ntc_bnr_imp",
            CLICK_EVENT: "pc_act_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_act_ntc_bnr_imp",
            CLICK_EVENT: "mo_act_ntc_bnr_clk"
        }
    },
    CONTEST_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_ctst_ntc_bnr_imp",
            CLICK_EVENT: "pc_ctst_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_ctst_ntc_bnr_imp",
            CLICK_EVENT: "mo_ctst_ntc_bnr_clk"
        }
    },
    EDUCATION_NOTICE: {
        PC: {
            IMPRESSION_EVENT: "pc_edu_ntc_bnr_imp",
            CLICK_EVENT: "pc_edu_ntc_bnr_clk"
        },
        MOBILE: {
            IMPRESSION_EVENT: "mo_edu_ntc_bnr_imp",
            CLICK_EVENT: "mo_edu_ntc_bnr_clk"
        },
        APP: {
            IMPRESSION_EVENT: "app_edu_ntc_bnr_imp",
            CLICK_EVENT: "app_edu_ntc_bnr_clk"
        }
    }
};


/***/ }),

/***/ 68545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32912);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);




/**
 * 단일한 랜덤의 광고 지면을 응답받아야 하는 경우 사용합니다.
 * @param  TUseGetAdByPlacementCodeAndCurrentTimeParams
 * @returns
 */ var useGetAdByPlacementCodeAndCurrentTime = function(param) {
    var code = param.code;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var page = router.query.page;
    var currentTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var currentDate = new Date();
        return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(currentDate, "HH:mm:ss");
    }, [
        page
    ]);
    var ref = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useGqlCurrentAdByPlacementCodeAndCurrentTimeQuery */ .hf9)({
        variables: {
            code: code,
            currentTime: currentTime
        }
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        ad: data === null || data === void 0 ? void 0 : data.currentAdByPlacementCodeAndCurrentTime,
        loading: loading,
        error: error
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetAdByPlacementCodeAndCurrentTime);


/***/ }),

/***/ 31374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CZ": function() { return /* binding */ getEducationTopPinnedBannerImpressionByPlatform; },
/* harmony export */   "PD": function() { return /* binding */ getEducationNoticeClickByPlatform; },
/* harmony export */   "Ph": function() { return /* binding */ getQnaBannerClickByPlatform; },
/* harmony export */   "Sw": function() { return /* binding */ getEducationTopPinnedBannerClickByPlatform; },
/* harmony export */   "h5": function() { return /* binding */ getQnaBannerImpressionByPlatform; },
/* harmony export */   "rH": function() { return /* binding */ getEducationNoticeImpressionByPlatform; },
/* harmony export */   "vz": function() { return /* binding */ getCoverLetterSearchClickByPlatform; },
/* harmony export */   "xu": function() { return /* binding */ getCoverLetterSearchImpressionByPlatform; }
/* harmony export */ });
/* harmony import */ var _constants_gtm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80979);

var getEducationNoticeImpressionByPlatform = function(isWebview) {
    if (isWebview) {
        return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.APP.IMPRESSION_EVENT */ .U.EDUCATION_NOTICE.APP.IMPRESSION_EVENT;
    }
    return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.MOBILE.IMPRESSION_EVENT */ .U.EDUCATION_NOTICE.MOBILE.IMPRESSION_EVENT;
};
var getEducationTopPinnedBannerImpressionByPlatform = function(isWebview) {
    if (isWebview) {
        return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.APP.IMPRESSION_EVENT */ .c.EDUCATION_TOP_PINNED_BANNER.APP.IMPRESSION_EVENT;
    }
    return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.MOBILE.IMPRESSION_EVENT */ .c.EDUCATION_TOP_PINNED_BANNER.MOBILE.IMPRESSION_EVENT;
};
var getEducationNoticeClickByPlatform = function(isWebview) {
    if (isWebview) {
        return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.APP.CLICK_EVENT */ .U.EDUCATION_NOTICE.APP.CLICK_EVENT;
    }
    return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.MOBILE.CLICK_EVENT */ .U.EDUCATION_NOTICE.MOBILE.CLICK_EVENT;
};
var getEducationTopPinnedBannerClickByPlatform = function(isWebview) {
    if (isWebview) {
        return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.APP.CLICK_EVENT */ .c.EDUCATION_TOP_PINNED_BANNER.APP.CLICK_EVENT;
    }
    return _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.MOBILE.CLICK_EVENT */ .c.EDUCATION_TOP_PINNED_BANNER.MOBILE.CLICK_EVENT;
};
3;
var getQnaBannerImpressionByPlatform = function(isWebview) {
    var ref, ref1;
    return isWebview ? (ref = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.RECRUIT_QNA_BOTTOM.APP */ .c.RECRUIT_QNA_BOTTOM.APP) === null || ref === void 0 ? void 0 : ref.IMPRESSION_EVENT : (ref1 = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.RECRUIT_QNA_BOTTOM.MOBILE */ .c.RECRUIT_QNA_BOTTOM.MOBILE) === null || ref1 === void 0 ? void 0 : ref1.IMPRESSION_EVENT;
};
var getQnaBannerClickByPlatform = function(isWebview) {
    var ref, ref1;
    return isWebview ? (ref = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.RECRUIT_QNA_BOTTOM.APP */ .c.RECRUIT_QNA_BOTTOM.APP) === null || ref === void 0 ? void 0 : ref.CLICK_EVENT : (ref1 = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.RECRUIT_QNA_BOTTOM.MOBILE */ .c.RECRUIT_QNA_BOTTOM.MOBILE) === null || ref1 === void 0 ? void 0 : ref1.CLICK_EVENT;
};
var getCoverLetterSearchImpressionByPlatform = function(isWebview) {
    var ref;
    if (isWebview) {
        var ref1;
        return ((ref1 = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.COVER_LETTER_SEARCH.APP */ .c.COVER_LETTER_SEARCH.APP) === null || ref1 === void 0 ? void 0 : ref1.IMPRESSION_EVENT) || "";
    }
    return ((ref = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.COVER_LETTER_SEARCH.MOBILE */ .c.COVER_LETTER_SEARCH.MOBILE) === null || ref === void 0 ? void 0 : ref.IMPRESSION_EVENT) || "";
};
var getCoverLetterSearchClickByPlatform = function(isWebview) {
    var ref;
    if (isWebview) {
        var ref1;
        return ((ref1 = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.COVER_LETTER_SEARCH.APP */ .c.COVER_LETTER_SEARCH.APP) === null || ref1 === void 0 ? void 0 : ref1.CLICK_EVENT) || "";
    }
    return ((ref = _constants_gtm__WEBPACK_IMPORTED_MODULE_0__/* .GTM_EVENT.COVER_LETTER_SEARCH.MOBILE */ .c.COVER_LETTER_SEARCH.MOBILE) === null || ref === void 0 ? void 0 : ref.CLICK_EVENT) || "";
};


/***/ }),

/***/ 24033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ pushGTMCampaignId; }
/* harmony export */ });
/**
 * Campaign ID를 포함한 GTM 이벤트를 발생시키는 함수
 * window.dataLayer가 존재할 경우 이벤트를 push합니다.
 *
 * @param eventName - GTM에서 트리거로 사용될 이벤트 이름
 * @param campaignId - 캠페인 ID
 * @example
 * pushGTMCampaignId({
 *   eventName: 'view_campaign',
 *   campaign_id: '12345'
 * })
 */ var pushGTMCampaignId = function(param) {
    var eventName = param.eventName, campaignId = param.campaignId;
    if (!(window === null || window === void 0 ? void 0 : window.dataLayer) || !campaignId || !eventName) {
        return;
    }
    window.dataLayer.push({
        event: eventName,
        campaign_id: campaignId
    });
};


/***/ }),

/***/ 479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useCoverLetterStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);



var useCoverLetterStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        currentMenu: "SEARCH",
        setCurrentMenu: function(menu) {
            set(function() {
                return {
                    currentMenu: menu
                };
            });
        },
        coverLetterId: undefined,
        setCoverLetterId: function(id) {
            set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    coverLetterId: id
                });
            });
        }
    };
});


/***/ }),

/***/ 36957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getLimitNumText; }
/* harmony export */ });
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93293);

var getLimitNumText = function(param) {
    var number = param.number, limit = param.limit;
    if (number <= limit) {
        return (0,utils__WEBPACK_IMPORTED_MODULE_0__/* .numberWithCommas */ .x6)(number);
    } else {
        return "".concat((0,utils__WEBPACK_IMPORTED_MODULE_0__/* .numberWithCommas */ .x6)(limit), "+");
    }
};


/***/ }),

/***/ 90917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ KakaoShareButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var constants_kakaoDeveloper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42616);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var KakaoButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "KakaoShareButton__KakaoButton",
    componentId: "sc-e8b99ca9-0"
})(_templateObject());
var KakaoShareButton = function(param) {
    var _objectType = param.objectType, objectType = _objectType === void 0 ? "feed" : _objectType, _title = param.title, title = _title === void 0 ? "" : _title, _text = param.text, text = _text === void 0 ? "" : _text, thumbnailImage = param.thumbnailImage;
    // const shareButtonRef = useRef<HTMLDivElement | null>(null)
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (!(window === null || window === void 0 ? void 0 : (ref = window.Kakao) === null || ref === void 0 ? void 0 : ref.isInitialized())) {
            var ref1;
            window === null || window === void 0 ? void 0 : (ref1 = window.Kakao) === null || ref1 === void 0 ? void 0 : ref1.init(constants_kakaoDeveloper__WEBPACK_IMPORTED_MODULE_4__/* .KAKAO_INIT_KEY */ .B);
        }
    }, []);
    var handleClick = function() {
        var kakao = window.Kakao;
        if (!kakao) {
            return;
        }
        switch(objectType){
            case "text":
                {
                    kakao.Share.sendDefault({
                        objectType: "text",
                        text: text,
                        link: {
                            webUrl: window.location.href,
                            mobileWebUrl: window.location.href
                        }
                    });
                    break;
                }
            default:
                {
                    kakao.Share.sendDefault({
                        objectType: "feed",
                        content: {
                            title: "[링커리어] ".concat(title),
                            imageUrl: thumbnailImage ? thumbnailImage.url : "https://linkareer.com/static/images/linkareer.png",
                            link: {
                                webUrl: window.location.href,
                                mobileWebUrl: window.location.href
                            }
                        }
                    });
                    break;
                }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(KakaoButton, {
        onClick: handleClick
    });
};


/***/ }),

/***/ 34557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82222);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89659);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);












var NextComposed = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var as = props.as, href = props.href, replace = props.replace, scroll = props.scroll, passHref = props.passHref, shallow = props.shallow, prefetch = props.prefetch, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "as",
        "href",
        "replace",
        "scroll",
        "passHref",
        "shallow",
        "prefetch"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: prefetch,
        as: as,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: passHref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    });
});
NextComposed.displayName = "NextComposed";
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        inherit: {
            color: "inherit",
            "&:hover": {
                color: "inherit",
                textDecoration: "none !important"
            }
        }
    };
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
var Link = function(props) {
    var _colorInherit = props.colorInherit, colorInherit = _colorInherit === void 0 ? false : _colorInherit, _renderATag = props.renderATag, renderATag = _renderATag === void 0 ? false : _renderATag, _activeClassName = props.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, classNameProps = props.className, innerRef = props.innerRef, naked = props.naked, href = props.href, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "colorInherit",
        "renderATag",
        "activeClassName",
        "className",
        "innerRef",
        "naked",
        "href"
    ]);
    var classes = useStyles();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pathname = typeof href === "string" ? href : href.pathname;
    var _obj;
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classNameProps, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.inherit, colorInherit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, activeClassName, router.pathname === pathname && activeClassName), _obj));
    if (renderATag) {
        if (typeof href !== "string") {
            console.error("Warning: Failed prop type: Invalid prop `href` of type `".concat(typeof href === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(href), "` supplied to") + "`components/Link` + renderATag: true, expected `string`");
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href,
            className: className,
            ref: innerRef
        }, other));
    }
    if (naked) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href,
            className: className,
            ref: innerRef
        }, other));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        component: NextComposed,
        className: className,
        ref: innerRef,
        href: href
    }, other));
};
var LinkWithRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Link, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        innerRef: ref
    }));
});
LinkWithRef.displayName = "LinkWithRef";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(LinkWithRef));


/***/ }),

/***/ 83740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var components_custom_material_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51300);
/* harmony import */ var svgIcons_ArrowLeft__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5039);
/* harmony import */ var svgIcons_ArrowRight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14615);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding-top: 20px;\n      background-color: #fafafa;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        margin-left: 5px;\n        margin-right: 5px;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ",
        "\n\n  .button-arrow {\n    &-next {\n      padding-bottom: 11px;\n      padding-top: 12px;\n      margin-left: 10px;\n    }\n\n    &-previous {\n      padding-bottom: 11px;\n      padding-top: 12px;\n      margin-right: 10px;\n    }\n\n    &-next,\n    &-previous {\n      .icon-arrow {\n        width: 9px;\n        height: 16px;\n      }\n    }\n  }\n\n  .button-page-number {\n    line-height: 1;\n    font-size: 15px;\n    padding-bottom: 11px;\n    padding-top: 12px;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 10px;\n    padding-right: 10px;\n    background-color: transparent;\n    color: #dddddd;\n    font-weight: 500;\n    &:hover {\n      background-color: transparent;\n    }\n\n    ",
        "\n\n    &.active-page {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Pagination = function(param) {
    var pagination = param.pagination;
    var renderVisiblePiece = function renderVisiblePiece(piece) {
        if (piece.type === "next") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_custom_material_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
            className: "button-arrow-next",
            disabled: piece.isDisabled,
            onClick: function() {
                return goToPage(piece.pageNumber);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_ArrowRight__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "icon-arrow"
            })
        }, "next");
        if (piece.type === "previous") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_custom_material_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
            className: "button-arrow-previous",
            disabled: piece.isDisabled,
            onClick: function() {
                return goToPage(piece.pageNumber);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_ArrowLeft__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "icon-arrow"
            })
        }, "previous");
        if (piece.type === "page-number") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_custom_material_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("button-page-number", {
                    "active-page": activePage === piece.pageNumber
                }),
                onClick: function() {
                    return goToPage(piece.pageNumber);
                },
                children: piece.pageNumber
            }, piece.pageNumber);
        }
        return null;
    };
    var visiblePieces = pagination.visiblePieces, activePage = pagination.activePage, goToPage = pagination.goToPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: visiblePieces.map(renderVisiblePiece)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Pagination__StyledWrapper",
    componentId: "sc-f2d63645-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1());
}, function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
});


/***/ }),

/***/ 73142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8136);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var svgIcons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43785);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94761);
/* harmony import */ var _KakaoShareButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90917);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  height: 80px;\n  background-image: url(/static/images/activity/share-facebook.png);\n  background-size: 60px 60px;\n  background-position: top center;\n  background-repeat: no-repeat;\n  text-align: center;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var FacebookButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props));
}).withConfig({
    displayName: "ShareModal__FacebookButton",
    componentId: "sc-4ffc8be-0"
})(_templateObject());
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            margin: "auto",
            wdith: "calc(100% - 32px)",
            maxWidth: 350,
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            position: "relative",
            marginTop: 15,
            padding: 0
        },
        header: {
            display: "flex",
            flexGrow: 1,
            justifyContent: "space-between",
            height: 64,
            backgroundColor: "#002f56",
            borderRadius: "2px 2px 0 0",
            padding: "18px 24px",
            color: "#ffffff"
        },
        title: {
            fontSize: "1.4rem",
            fontWeight: 500,
            color: "#ffffff"
        },
        svgIcon: {
            cursor: "pointer"
        },
        body: {
            padding: "32px 24px"
        },
        buttonsWrapper: {
            display: "flex"
        },
        iconButtonBase: {
            flex: 1,
            height: 80,
            backgroundSize: "60px 60px",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
            textAlign: "center",
            cursor: "pointer"
        },
        facebook: {
            backgroundImage: "url(/static/images/activity/share-facebook.png)"
        },
        naver: {
            backgroundImage: "url(/static/images/activity/share-naver.png)"
        },
        kakao: {
            backgroundImage: "url(/static/images/activity/share-kakao.png)"
        },
        linkBoxWrapper: {
            position: "relative",
            width: "100%",
            marginTop: 10,
            padding: "0 10px"
        },
        linkBox: {
            width: "100%",
            height: "auto",
            padding: "10px 40px 10px 8px",
            border: "1px solid #cddae3",
            borderRadius: 2,
            backgroundColor: "#e6ecf0",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        copyButton: {
            position: "absolute",
            top: 7,
            right: 18,
            width: 30,
            color: theme.palette.primary.main,
            textDecoration: "underline",
            cursor: "pointer"
        }
    };
});
var ShareModal = function(param) {
    var _title = param.title, title = _title === void 0 ? "링크 공유" : _title, open = param.open, onModalClose = param.onModalClose, url = param.url, quote = param.quote, kakaoShareProps = param.kakaoShareProps;
    var classes = useStyles();
    var handleNaverShareButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var url = window.location.href;
        var label = "[링커리어] ".concat(quote);
        var shareURL = "http://share.naver.com/web/shareView.nhn?url=".concat(encodeURI(url), "&title=").concat(encodeURI(label));
        window.open(shareURL);
    }, [
        quote
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .WideInfoModalContainer */ .a3, {
        isOpen: open,
        onRequestClose: onModalClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: classes.header,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: classes.title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            onClick: onModalClose,
                            className: classes.svgIcon
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: classes.body,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: classes.buttonsWrapper,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FacebookButton, {
                                    url: url,
                                    quote: quote
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    onClick: handleNaverShareButtonClick,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.iconButtonBase, classes.naver)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.iconButtonBase, classes.kakao),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_KakaoShareButton__WEBPACK_IMPORTED_MODULE_6__/* .KakaoShareButton */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, kakaoShareProps), {
                                        title: quote
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: classes.linkBoxWrapper,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                    type: "textbox",
                                    value: url,
                                    className: classes.linkBox,
                                    readOnly: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    text: url,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: classes.copyButton,
                                        children: "복사"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShareModal);


/***/ }),

/***/ 89068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_FormLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96019);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22601);
/* harmony import */ var _material_ui_core_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58189);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _RequiredLabelText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79268);








// @ts-ignore




var useStyle = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return {
        requiredLabel: {
            "&::before": {
                content: "none !important"
            }
        }
    };
});
var LabelWithHelper = function(props) {
    var helperText = props.helperText, label = props.label, _labelRequiredVariant = props.labelRequiredVariant, labelRequiredVariant = _labelRequiredVariant === void 0 ? "default" : _labelRequiredVariant, FormLabelProps = props.FormLabelProps, FormHelperTextProps = props.FormHelperTextProps;
    var classes = useStyle();
    var muiFormControl = (0,_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var fcs = (0,_material_ui_core_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (label || helperText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            children: [
                label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    error: false,
                    focused: false,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, classes.requiredLabel, labelRequiredVariant === "text"))
                }, FormLabelProps), {
                    children: [
                        label,
                        labelRequiredVariant === "text" && fcs.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RequiredLabelText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                    ]
                })),
                helperText && !label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                helperText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, FormHelperTextProps), {
                    children: helperText
                }))
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LabelWithHelper);


/***/ }),

/***/ 79268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);


var useStyle = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.error.main
        }
    };
});
var RequiredLabelText = function() {
    var classes = useStyle();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classes.root,
        children: "(필수)"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequiredLabelText);


/***/ }),

/***/ 91661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_material_ui_TextField; }
});

// UNUSED EXPORTS: useStyle

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(38799);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 7 modules
var Select = __webpack_require__(56790);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(19302);
// EXTERNAL MODULE: ./src/svgIcons/Check.tsx
var Check = __webpack_require__(17387);
// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/utils/domElementID.ts
var getInputHelperID = function(id) {
    return "".concat(id, "-helper-text");
};
var getInputLabelID = function(id) {
    return "".concat(id, "-label");
};

// EXTERNAL MODULE: ./src/components/custom-material-ui/LabelWithHelper.tsx
var LabelWithHelper = __webpack_require__(89068);
;// CONCATENATED MODULE: ./src/components/custom-material-ui/TextField.tsx





















var useStyle = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        select: {
            minWidth: 250
        },
        textFieldEndAdornmentGridContainer: {
            "div + &": {
                marginTop: 10
            }
        },
        textFieldStartAdornmentGridItem: {
            marginRight: 5,
            display: "flex",
            whiteSpace: "nowrap"
        },
        textFieldEndAdornmentGridItem: {
            marginLeft: 5,
            display: "flex",
            whiteSpace: "nowrap"
        },
        checkIcon: {
            fontSize: 14,
            color: theme.palette.primary.main
        },
        expandMore: {
            fontSize: 14
        },
        hintMessage: {
            fontSize: 12,
            fontWeight: 400,
            marginTop: 10,
            color: theme.palette.text.hint
        }
    };
}, {
    name: "CustomTextField"
});
var TextField = function(props, ref) {
    var autoComplete = props.autoComplete, _autoFocus = props.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, children = props.children, className = props.className, _color = props.color, color = _color === void 0 ? "primary" : _color, defaultValue = props.defaultValue, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, _error = props.error, error = _error === void 0 ? false : _error, FormHelperTextProps = props.FormHelperTextProps, _fullWidth = props.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, hintMessage = props.hintMessage, id = props.id, FormLabelProps = props.FormLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _multiline = props.multiline, multiline = _multiline === void 0 ? false : _multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _required = props.required, required = _required === void 0 ? false : _required, rows = props.rows, rowsMax = props.rowsMax, _select = props.select, select = _select === void 0 ? false : _select, SelectProps = props.SelectProps, type = props.type, value = props.value, textFieldEndAdornment = props.textFieldEndAdornment, textFieldStartAdornment = props.textFieldStartAdornment, _debounceDelayMS = props.debounceDelayMS, debounceDelayMS = _debounceDelayMS === void 0 ? 0 : _debounceDelayMS, onDebounceChange = props.onDebounceChange, _isAsyncValid = props.isAsyncValid, isAsyncValid = _isAsyncValid === void 0 ? false : _isAsyncValid, _isAsyncValidating = props.isAsyncValidating, isAsyncValidating = _isAsyncValidating === void 0 ? false : _isAsyncValidating, _labelRequiredVariant = props.labelRequiredVariant, labelRequiredVariant = _labelRequiredVariant === void 0 ? "default" : _labelRequiredVariant, other = (0,_object_without_properties/* default */.Z)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "hintMessage",
        "id",
        "FormLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "select",
        "SelectProps",
        "type",
        "value",
        "textFieldEndAdornment",
        "textFieldStartAdornment",
        "debounceDelayMS",
        "onDebounceChange",
        "isAsyncValid",
        "isAsyncValidating",
        "labelRequiredVariant"
    ]);
    var classes = useStyle();
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,useDebouncedCallback/* default */.Z)(function(value) {
        if (onDebounceChange) {
            onDebounceChange(value);
        }
    }, debounceDelayMS), 2), debouncedCallback = _$ref[0], cancel = _$ref[1];
    (0,react.useEffect)(function() {
        if (!debounceDelayMS) {
            cancel();
        }
    }, [
        debounceDelayMS,
        cancel
    ]);
    var handleChange = function(event) {
        if (onChange) {
            onChange(event);
        }
        debouncedCallback(event.target.value);
    };
    var InputMore = {};
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) {
            InputMore.id = undefined;
        }
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? getInputHelperID(id) : undefined;
    var inputLabelId = label && id ? getInputLabelID(id) : undefined;
    var asyncValidating = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 20
            })
        })
    });
    var asyncValidatingPass = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                className: classes.checkIcon
            })
        })
    });
    var endAdornment;
    if (isAsyncValidating) {
        endAdornment = asyncValidating;
    } else if (isAsyncValid && !error) {
        endAdornment = asyncValidatingPass;
    } else {
        endAdornment = InputProps === null || InputProps === void 0 ? void 0 : InputProps.endAdornment;
    }
    var InputElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disableUnderline: true,
        error: error,
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: handleChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps), {
        endAdornment: endAdornment
    }));
    var input = select ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement,
        IconComponent: ExpandMore/* default */.Z,
        displayEmpty: true
    }, SelectProps), {
        children: children
    })) : InputElement;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, (0,_define_property/* default */.Z)({}, classes.select, select), className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color
    }, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithHelper/* default */.Z, {
                helperText: helperText,
                label: label,
                required: required,
                FormLabelProps: (0,_object_spread/* default */.Z)({
                    htmlFor: id,
                    id: inputLabelId
                }, FormLabelProps),
                FormHelperTextProps: (0,_object_spread/* default */.Z)({
                    id: helperTextId
                }, FormHelperTextProps),
                labelRequiredVariant: labelRequiredVariant
            }),
            textFieldEndAdornment || textFieldStartAdornment ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                wrap: "nowrap",
                container: true,
                alignItems: "stretch",
                className: classes.textFieldEndAdornmentGridContainer,
                children: [
                    textFieldStartAdornment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        className: classes.textFieldStartAdornmentGridItem,
                        children: textFieldStartAdornment
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: true,
                        children: input
                    }),
                    textFieldEndAdornment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        className: classes.textFieldEndAdornmentGridItem,
                        children: textFieldEndAdornment
                    })
                ]
            }) : input,
            hintMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                className: classes.hintMessage,
                children: hintMessage
            })
        ]
    }));
};
/* harmony default export */ var custom_material_ui_TextField = (/*#__PURE__*/(0,react.forwardRef)(TextField));


/***/ }),

/***/ 51300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nv": function() { return /* reexport safe */ _TextField__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "zx": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91661);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76318);
/* harmony import */ var _LabelWithHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89068);
/* harmony import */ var _RequiredLabelText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79268);






/***/ }),

/***/ 94761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yw": function() { return /* reexport */ components_button/* BorderlessButton */.Yw; },
  "zx": function() { return /* reexport */ components_button/* Button */.zx; },
  "W2": function() { return /* reexport */ layout_Container; },
  "rZ": function() { return /* reexport */ InfoModalContainer; },
  "a3": function() { return /* reexport */ WideInfoModalContainer; }
});

// UNUSED EXPORTS: BaseModalContainer, Intent, Modal, ModalBackground, ModalCard, ModalCardBody, ModalCardFoot, ModalCardHead, ModalCardTitle, ModalClose, ModalContent, mapButtonProps

// EXTERNAL MODULE: ./src/components/base.ts
var base = __webpack_require__(43876);
// EXTERNAL MODULE: ./src/components/button.tsx
var components_button = __webpack_require__(14020);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layout.tsx



var layout_Container = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread/* default */.Z)({}, (0,base/* mapBulmaProps */.n7)(props, "container")));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js
var Portal = __webpack_require__(76234);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.modules/util/classnames.ts
var classnames = __webpack_require__(80007);
;// CONCATENATED MODULE: ./src/components/modal.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  html {\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 200;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 768px !important;\n  overflow: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var Modal = function(_param) /*#__PURE__*/ {
    var active = _param.active, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "active"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,src_object_spread/* default */.Z)({}, (0,base/* mapBulmaProps */.n7)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, other), {
        className: (0,classnames/* classNames */.A)(other.className, {
            "is-active": active
        })
    }), "modal")));
};
var ModalBackground = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread/* default */.Z)({}, (0,base/* mapBulmaProps */.n7)(props, "modal-background")));
};
var ModalContent = function(props) {
    var _ref = (0,base/* mapBulmaProps */.n7)(props, "modal-content"), children = _ref.children, other = (0,src_object_without_properties/* default */.Z)(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var ModalClose = function(props) {
    return /*#__PURE__*/ _jsx("button", _object_spread({}, mapBulmaProps(mapButtonProps(props), "modal-close")));
};
var ModalCard = function(props) {
    return /*#__PURE__*/ _jsx("div", _object_spread({}, mapBulmaProps(props, "modal-card")));
};
var ModalCardHead = function(props) {
    var _ref = mapBulmaProps(props, "modal-card-head"), children = _ref.children, other = _object_without_properties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("header", _object_spread_props(_object_spread({}, other), {
        children: children
    }));
};
var ModalCardTitle = function(props) {
    var _ref = mapBulmaProps(props, "modal-card-title"), children = _ref.children, other = _object_without_properties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("p", _object_spread_props(_object_spread({}, other), {
        children: children
    }));
};
var ModalCardBody = function(props) {
    var _ref = mapBulmaProps(props, "modal-card-body"), children = _ref.children, other = _object_without_properties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("section", _object_spread_props(_object_spread({}, other), {
        children: children
    }));
};
var ModalCardFoot = function(props) {
    var _ref = mapBulmaProps(props, "modal-card-foot"), children = _ref.children, other = _object_without_properties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("footer", _object_spread_props(_object_spread({}, other), {
        children: children
    }));
};
// TODO 타입 에러 제거
// @ts-ignore
var GlobalOverflowHiddenStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject());
var InfoModalContainer = function(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Portal/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalOverflowHiddenStyle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoModalStyledWrapper, {
                    active: isOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBackground, {
                            onClick: onRequestClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "modal-close is-large",
                            "aria-label": "close",
                            onClick: onRequestClose
                        })
                    ]
                })
            ]
        })
    });
};
var InfoModalStyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Modal).withConfig({
    displayName: "modal__InfoModalStyledWrapper",
    componentId: "sc-6d264de9-0"
})(_templateObject1());
var WideInfoModalContent = (0,styled_components_browser_esm/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, (0,src_object_spread/* default */.Z)({}, props));
}).withConfig({
    displayName: "modal__WideInfoModalContent",
    componentId: "sc-6d264de9-1"
})(_templateObject2());
var WideInfoModalContainer = function(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Portal/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalOverflowHiddenStyle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                    active: isOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBackground, {
                            onClick: onRequestClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WideInfoModalContent, {
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
var useDeepDarkBackdropStyles = (0,makeStyles/* default */.Z)({
    root: {
        backgroundColor: "rgba(10, 10, 10, 0.86)"
    }
});
var DeepDarkBackdrop = function(props) {
    var classes = useDeepDarkBackdropStyles();
    return /*#__PURE__*/ _jsx(Backdrop, _object_spread_props(_object_spread({}, props), {
        className: classes.root
    }));
};
var useBaseModalContainer = (0,makeStyles/* default */.Z)({
    container: {
        position: "absolute",
        left: "50%",
        bottom: "20px",
        width: "95%",
        borderRadius: "20px",
        transform: "translate(-50%, -0%)",
        "&:focus": {
            outline: "none"
        },
        backgroundColor: "#ffffff"
    }
});
var BaseModalContainer = function(param) {
    var isOpen = param.isOpen, onModalClose = param.onModalClose, children = param.children;
    var classes = useBaseModalContainer();
    return /*#__PURE__*/ _jsx(MuiModal, {
        open: isOpen,
        onClose: onModalClose,
        closeAfterTransition: true,
        BackdropComponent: DeepDarkBackdrop,
        children: /*#__PURE__*/ _jsx(Fade, {
            in: isOpen,
            children: /*#__PURE__*/ _jsx(Container, {
                className: classes.container,
                children: children || ""
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/index.ts






/***/ }),

/***/ 42783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ IS_SERVER; }
/* harmony export */ });
var IS_SERVER = "object" === "undefined";


/***/ }),

/***/ 52169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ih": function() { return /* binding */ PREVIEW_PAGE_SIZE; },
/* harmony export */   "lW": function() { return /* binding */ PC_BUTTON_SIZE; },
/* harmony export */   "v9": function() { return /* binding */ LIST_PAGE_SIZE; },
/* harmony export */   "zw": function() { return /* binding */ MOBILE_BUTTON_SIZE; }
/* harmony export */ });
var PC_BUTTON_SIZE = 10;
var MOBILE_BUTTON_SIZE = 5;
var PREVIEW_PAGE_SIZE = 5;
var LIST_PAGE_SIZE = 20;


/***/ }),

/***/ 58432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZQ": function() { return /* binding */ IOS_APP_VERSIONS; },
/* harmony export */   "hk": function() { return /* binding */ AOS_APP_VERSIONS; },
/* harmony export */   "sJ": function() { return /* binding */ VERIFIED_APP_VERSIONS; }
/* harmony export */ });
var VERIFIED_APP_VERSIONS = {
    CAREER_NAVER_LICENSE: "CAREER_NAVER_LICENSE",
    COVER_LETTER_AD_EDUCATION: "COVER_LETTER_AD_EDUCATION",
    SCRAP_USER_STATISTICS: "SCRAP_USER_STATISTICS",
    TEAM_RECRUIT: "TEAM_RECRUIT",
    COMPANY_INFO: "COMPANY_INFO"
};
var IOS_APP_VERSIONS = {
    CAREER_NAVER_LICENSE: "1.22.0",
    COVER_LETTER_AD_EDUCATION: "1.24.1",
    SCRAP_USER_STATISTICS: "1.29.0",
    TEAM_RECRUIT: "1.46.0",
    COMPANY_INFO: "2.1.0"
};
var AOS_APP_VERSIONS = {
    CAREER_NAVER_LICENSE: "1.22.0",
    COVER_LETTER_AD_EDUCATION: "1.24.1",
    SCRAP_USER_STATISTICS: "1.29.0",
    TEAM_RECRUIT: "1.46.0",
    COMPANY_INFO: "2.1.0"
};


/***/ }),

/***/ 27914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export defaultComputeVisiblePieces */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// https://github.com/eliseumds/react-pagination-hook/blob/master/src/react-pagination-hook.ts

// x = disabled, o = enable
// (1 x) < 1 2 3 4 5 > (6 o)
// (2 o) < 6 7 8 9 10 > 1(1 o)
// (3 o) < 11 12 13 14 15 > 1(6 o)
// (4 o) < 16 17 18 19 20 > 2(0 o)
// (5 o) < 21 22 23 > 2(3 x)
function defaultComputeVisiblePieces(config) {
    var numberOfPages = config.numberOfPages, maxButtons = config.maxButtons, activePage = config.activePage;
    var visiblePieces = [];
    if (!numberOfPages) {
        return [];
    }
    var startPage = maxButtons * (Math.ceil(activePage / maxButtons) - 1) + 1;
    var prePageNumber = Math.max(1, startPage - maxButtons);
    visiblePieces.push({
        type: "previous",
        pageNumber: prePageNumber,
        isDisabled: startPage - maxButtons < 1
    });
    for(var i = 0; i < maxButtons && i + startPage <= numberOfPages; i++){
        visiblePieces.push({
            type: "page-number",
            pageNumber: i + startPage
        });
    }
    visiblePieces.push({
        type: "next",
        pageNumber: Math.min(numberOfPages, startPage + maxButtons),
        isDisabled: startPage + maxButtons > numberOfPages
    });
    return visiblePieces;
}
function usePagination(config) {
    var _maxButtons = config.maxButtons, maxButtons = _maxButtons === void 0 ? 5 : _maxButtons, activePage = config.activePage;
    var setActivePage = config.setActivePage, scrollToTop = config.scrollToTop;
    var _computeVisiblePieces = config.computeVisiblePieces, computeVisiblePieces = _computeVisiblePieces === void 0 ? defaultComputeVisiblePieces : _computeVisiblePieces, tmp = config.numberOfPages, numberOfPagesProp = tmp === void 0 ? 0 : tmp;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(numberOfPagesProp), numberOfPagesState = ref[0], setNumberOfPages = ref[1];
    // prop 으로 전달 된 numberOfPages 가 있으면 사용
    var numberOfPages = numberOfPagesProp || numberOfPagesState;
    if (numberOfPages && activePage > numberOfPages) {
        activePage = numberOfPages;
    }
    if (numberOfPages && maxButtons > numberOfPages) {
        maxButtons = numberOfPages;
    }
    var isFirst = activePage === 1;
    var isLast = activePage === numberOfPages;
    var hasPrevious = numberOfPages > 1 && activePage > 1;
    var hasNext = activePage < numberOfPages;
    var visiblePieces = computeVisiblePieces({
        maxButtons: maxButtons,
        activePage: activePage,
        numberOfPages: numberOfPages
    });
    var goToPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(pageNumber) {
        if (setActivePage) {
            setActivePage(pageNumber);
            if (scrollToTop && "object" !== "undefined") {
                window.scrollTo(0, 0);
            }
        }
    }, [
        setActivePage
    ]);
    var setNumberOfPagesCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newNumberOfPages) {
        setNumberOfPages(newNumberOfPages);
    }, []);
    return {
        activePage: activePage,
        isFirst: isFirst,
        isLast: isLast,
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        visiblePieces: visiblePieces,
        goToPage: goToPage,
        setNumberOfPages: setNumberOfPagesCallback,
        numberOfPages: numberOfPages,
        maxButtons: maxButtons,
        computeVisiblePieces: computeVisiblePieces
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (usePagination);


/***/ }),

/***/ 48889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ARTICLE_ID_SELECTOR; }
/* harmony export */ });
var ARTICLE_ID_SELECTOR = "coverLetterContent";


/***/ }),

/***/ 64295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screens_CoverLetterItemScreen; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/PageLayout/index.tsx + 4 modules
var PageLayout = __webpack_require__(53949);
// EXTERNAL MODULE: ./src/constants/paginations.ts
var paginations = __webpack_require__(52169);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/useSearchState.ts
var useSearchState = __webpack_require__(70665);
// EXTERNAL MODULE: ./src/style/mediaQuery.ts
var mediaQuery = __webpack_require__(32091);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var src_context = __webpack_require__(52737);
// EXTERNAL MODULE: ./src/app.modules/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(27963);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterList/CoverLetterListContent.tsx + 2 modules
var CoverLetterListContent = __webpack_require__(61813);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(19302);
// EXTERNAL MODULE: ./node_modules/react-waypoint/es/index.js + 1 modules
var es = __webpack_require__(83824);
// EXTERNAL MODULE: ./node_modules/lodash/fp/pick.js
var pick = __webpack_require__(4588);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/activityDetail/hooks/useShowComponentByAppVersion.ts
var useShowComponentByAppVersion = __webpack_require__(98284);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/adCode.ts
var adCode = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/app.feature/ad/hooks/useGetAdByPlacementCodeAndCurrentTime.ts
var useGetAdByPlacementCodeAndCurrentTime = __webpack_require__(68545);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/app.feature/ad/constants/gtm.ts
var gtm = __webpack_require__(80979);
// EXTERNAL MODULE: ./src/app.feature/ad/modules/gtmEvents.ts
var gtmEvents = __webpack_require__(24033);
// EXTERNAL MODULE: ./src/utils/optimizeImageUrl.ts
var optimizeImageUrl = __webpack_require__(65342);
;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/CoverLetterSearchBanner/CoverLetterSearchBanner.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .cover-letter-search-banner-image {\n    border-radius: 5px;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE = {
    width: 610,
    height: 80
};
var CoverLetterSearchBannerDesktop = function(param) {
    var ad = param.ad;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var activityUrl = ((ref = ad.activity) === null || ref === void 0 ? void 0 : ref.id) ? "/activity/".concat((ref1 = ad.activity) === null || ref1 === void 0 ? void 0 : ref1.id) : "";
    (0,react.useEffect)(function() {
        var ref;
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: gtm/* GTM_EVENT.COVER_LETTER_SEARCH.PC.IMPRESSION_EVENT */.c.COVER_LETTER_SEARCH.PC.IMPRESSION_EVENT,
            campaignId: ((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id) || ""
        });
    }, [
        router.query.id
    ]);
    var handleClickOutLink = function() {
        var ref, ref1;
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: gtm/* GTM_EVENT.COVER_LETTER_SEARCH.PC.CLICK_EVENT */.c.COVER_LETTER_SEARCH.PC.CLICK_EVENT,
            campaignId: ((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id) || ""
        });
        if ((ref1 = ad.campaign) === null || ref1 === void 0 ? void 0 : ref1.landingURL) {
            window.open(ad.campaign.landingURL, "_blank", "noopener, noreferrer");
        }
        if (activityUrl) {
            router.push(activityUrl);
        }
    };
    var alt = (ad === null || ad === void 0 ? void 0 : (ref2 = ad.campaign) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.campaignGroup) === null || ref3 === void 0 ? void 0 : ref3.name) ? "".concat(ad === null || ad === void 0 ? void 0 : (ref4 = ad.campaign) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.campaignGroup) === null || ref5 === void 0 ? void 0 : ref5.name, " 자만검 배너 이미지") : "자만검 배너 이미지";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        onClick: handleClickOutLink,
        "aria-label": "Advertisement",
        role: "advertisement",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            className: "cover-letter-search-banner-image",
            alt: alt,
            width: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.width,
            height: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.height,
            loader: optimizeImageUrl/* imageLoader */.X,
            src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                url: (ref6 = ad.image) === null || ref6 === void 0 ? void 0 : ref6.url,
                width: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.width,
                height: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.height
            })
        }, "cover-letter-search-banner-image")
    });
};
/* harmony default export */ var CoverLetterSearchBanner_desktop = (CoverLetterSearchBannerDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterSearchBanner.desktop__StyledWrapper",
    componentId: "sc-f6d7ce5e-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/ad/desktop/CoverLetterSearchBanner/CoverLetterSearchBannerStatus.desktop.tsx





var CoverLetterSearchBannerStatusDesktop = function() {
    var ref = (0,useGetAdByPlacementCodeAndCurrentTime/* default */.Z)({
        code: adCode/* AD_CODE_ID.COVER_LETTER_SEARCH.PC */.Q7.COVER_LETTER_SEARCH.PC
    }), ad = ref.ad, loading = ref.loading, error = ref.error;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.width,
            height: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.height
        });
    }
    if (!ad || error) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterSearchBanner_desktop, {
        ad: ad
    });
};
/* harmony default export */ var CoverLetterSearchBannerStatus_desktop = (CoverLetterSearchBannerStatusDesktop);

// EXTERNAL MODULE: ./src/app.feature/ad/modules/getEventNameByPlatform.ts
var getEventNameByPlatform = __webpack_require__(31374);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/hooks/useFlutterInappwebview.ts
var useFlutterInappwebview = __webpack_require__(2165);
;// CONCATENATED MODULE: ./src/app.feature/ad/mobile/CoverLetterSearchBanner/CoverLetterSearchBanner.mobile.tsx

function CoverLetterSearchBanner_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .cover-letter-search-banner-image {\n    border-radius: 5px;\n  }\n"
    ]);
    CoverLetterSearchBanner_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE = {
    width: 330,
    height: 80
};
var CoverLetterSearchBannerMobile = function(param) {
    var ad = param.ad;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    (0,react.useEffect)(function() {
        var ref;
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: (0,getEventNameByPlatform/* getCoverLetterSearchImpressionByPlatform */.xu)(isWebview),
            campaignId: ((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id) || ""
        });
    }, [
        router.query.id
    ]);
    var activityUrl = ((ref = ad.activity) === null || ref === void 0 ? void 0 : ref.id) ? "/activity/".concat((ref1 = ad.activity) === null || ref1 === void 0 ? void 0 : ref1.id) : "";
    var pushGtmBannerClickEvent = function() {
        var ref;
        (0,gtmEvents/* pushGTMCampaignId */.h)({
            eventName: (0,getEventNameByPlatform/* getCoverLetterSearchClickByPlatform */.vz)(isWebview),
            campaignId: ((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.id) || ""
        });
    };
    var navigateToLandingUrl = function() {
        var ref;
        if (!((ref = ad.campaign) === null || ref === void 0 ? void 0 : ref.landingURL)) {
            return;
        }
        if (isWebview) {
            var ref1;
            fluterInappwebview.callHandler("requestOpenExternalBrowser", (ref1 = ad.campaign) === null || ref1 === void 0 ? void 0 : ref1.landingURL);
        } else {
            var ref2;
            window.open((ref2 = ad.campaign) === null || ref2 === void 0 ? void 0 : ref2.landingURL, "_blank", "noopener, noreferrer");
        }
    };
    var handleClickBanner = function() {
        pushGtmBannerClickEvent();
        if (activityUrl) {
            router.push(activityUrl);
        }
        navigateToLandingUrl();
    };
    var alt = (ad === null || ad === void 0 ? void 0 : (ref2 = ad.campaign) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.campaignGroup) === null || ref3 === void 0 ? void 0 : ref3.name) ? "".concat(ad === null || ad === void 0 ? void 0 : (ref4 = ad.campaign) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.campaignGroup) === null || ref5 === void 0 ? void 0 : ref5.name, " 자만검 배너 이미지") : "자만검 배너 이미지";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterSearchBanner_mobile_StyledWrapper, {
        onClick: handleClickBanner,
        "aria-label": "Advertisement",
        role: "advertisement",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            layout: "responsive",
            className: "cover-letter-search-banner-image",
            alt: alt,
            width: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.width,
            height: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.height,
            loader: optimizeImageUrl/* imageLoader */.X,
            src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                url: (ref6 = ad.image) === null || ref6 === void 0 ? void 0 : ref6.url,
                width: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.width,
                height: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.height
            })
        }, "cover-letter-search-banner-image")
    });
};
/* harmony default export */ var CoverLetterSearchBanner_mobile = (CoverLetterSearchBannerMobile);
var CoverLetterSearchBanner_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterSearchBanner.mobile__StyledWrapper",
    componentId: "sc-9057872f-0"
})(CoverLetterSearchBanner_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/ad/mobile/CoverLetterSearchBanner/CoverLetterSearchBannerStatus.mobile.tsx





var COVER_LETTER_MOBILE_AD_CODE = "mobile-coverletter-search-banner";
var CoverLetterSearchBannerStatusMobile = function() {
    var ref = (0,useGetAdByPlacementCodeAndCurrentTime/* default */.Z)({
        code: adCode/* AD_CODE_ID.COVER_LETTER_SEARCH.MOBILE */.Q7.COVER_LETTER_SEARCH.MOBILE
    }), ad = ref.ad, loading = ref.loading, error = ref.error;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.height
        });
    }
    if (!ad || error) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterSearchBanner_mobile, {
        ad: ad
    });
};
/* harmony default export */ var CoverLetterSearchBannerStatus_mobile = (CoverLetterSearchBannerStatusMobile);

// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(29312);
// EXTERNAL MODULE: ./src/constants/verifyAppVersion/verifyAppVersionList.ts
var verifyAppVersionList = __webpack_require__(58432);
// EXTERNAL MODULE: ./src/utils/utils.ts
var utils = __webpack_require__(55208);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 2 modules
var notistack_esm = __webpack_require__(29496);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/constants/common.ts
var common = __webpack_require__(42783);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/constate/dist/constate.es.js
var constate_es = __webpack_require__(11521);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
// EXTERNAL MODULE: ./src/components/ShareModal.tsx
var ShareModal = __webpack_require__(73142);
// EXTERNAL MODULE: ./src/utils/arrayFilterJoin.ts
var arrayFilterJoin = __webpack_require__(68182);
// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(15125);
// EXTERNAL MODULE: ./src/utils/coverLetter.ts
var utils_coverLetter = __webpack_require__(5126);
// EXTERNAL MODULE: ./src/pages/cover-letter/search.tsx + 18 modules
var search = __webpack_require__(81193);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/SelectionPopover.tsx







function SelectionPopover_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: ",
        ";\n  transform: ",
        ";\n"
    ]);
    SelectionPopover_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  border: 1px solid #757575;\n  background-color: #292929;\n  padding: 10px 5px;\n  border-radius: 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: ",
        ";\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 1rem;\n  background-color: #fff;\n  margin: 0;\n  border: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  &::after {\n    content: '';\n    display: block;\n    width: 14px;\n    height: 14px;\n    background-color: #292929;\n    border: none;\n    border-bottom: 1px solid #757575;\n    border-right: 1px solid #757575;\n    transform: rotate(45deg) translate(-6px, -6px);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: inherit;\n  font-weight: inherit;\n  color: #01a0ff;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















function useSelectionPopover() {
    var ref = (0,react.useState)(), selectionPopoverOption = ref[0], setSelectionPopoverOption = ref[1];
    var openPopover = function(option) {
        setSelectionPopoverOption(option);
    };
    var closePopover = function() {
        var selection = window.getSelection();
        selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
        setSelectionPopoverOption(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                selectionRect: null,
                scrapID: null
            });
        });
    };
    var getPopoverOption = function() {
        return selectionPopoverOption;
    };
    return {
        openPopover: openPopover,
        closePopover: closePopover,
        getPopoverOption: getPopoverOption,
        isOpen: !!selectionPopoverOption
    };
}
var ref = (0,_sliced_to_array/* default */.Z)((0,constate_es/* default */.Z)(useSelectionPopover), 2);
var SelectionPopoverProvider = ref[0], useSelectionPopoverContext = ref[1];
var SELECTION_POPOVER_ID = "selection-popover";
var SELECTION_POPOVER_WIDTH = 170;
var SELECTION_POPOVER_HEIGHT = 45;
var SELECTION_POPOVER_GAP = 10;
var SelectionPopoverActionIDs = [
    "selection-popover-scrap-btn",
    "selection-popover-copy-btn",
    "selection-popover-share-btn", 
];
var SelectionPopover = function(param) {
    var currentUser = param.currentUser, coverLetter = param.coverLetter, getBaseCoordinates = param.getBaseCoordinates;
    var router = (0,next_router.useRouter)();
    var linkareer = (0,src_context/* useDomain */.ay)().linkareer;
    var ref = (0,react.useState)(false), showLoginAlert = ref[0], setShowLoginAlert = ref[1];
    var ref1 = (0,react.useState)(false), showShareModal = ref1[0], setShowShareModal = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterParagraphScrapCreateMutation */.myh)(), 1), coverLetterParagraphScrapCreate = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterParagraphScrapDeleteMutation */.dVZ)(), 1), coverLetterParagraphScrapDelete = ref3[0];
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref4 = useSelectionPopoverContext(), getPopoverOption = ref4.getPopoverOption, closePopover = ref4.closePopover;
    var coverLetterID = router.query.id;
    var popoverOption = getPopoverOption();
    var selectionRect = popoverOption === null || popoverOption === void 0 ? void 0 : popoverOption.selectionRect;
    var scrapID = popoverOption === null || popoverOption === void 0 ? void 0 : popoverOption.scrapID;
    var scrapedParagraph = popoverOption === null || popoverOption === void 0 ? void 0 : popoverOption.selectionText;
    var ref5;
    var coverLetterContent = (ref5 = coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.content) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var selectionLeft = (ref6 = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.left) !== null && ref6 !== void 0 ? ref6 : 0;
    var ref7;
    var selectionTop = (ref7 = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.top) !== null && ref7 !== void 0 ? ref7 : 0;
    var ref8;
    var selectionWidth = (ref8 = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.width) !== null && ref8 !== void 0 ? ref8 : 0;
    var searchState = (0,search.parseQuery)(router === null || router === void 0 ? void 0 : router.query);
    var isOpen = !!selectionRect;
    var popoverLeft = selectionLeft + selectionWidth / 2 - SELECTION_POPOVER_WIDTH / 2;
    var popoverTop = selectionTop - SELECTION_POPOVER_HEIGHT - SELECTION_POPOVER_GAP;
    var baseCoordinates = getBaseCoordinates === null || getBaseCoordinates === void 0 ? void 0 : getBaseCoordinates();
    if (baseCoordinates) {
        popoverLeft = popoverLeft - baseCoordinates.left;
        popoverTop = popoverTop - baseCoordinates.top;
    }
    if (!common/* IS_SERVER */.W) {
        if (popoverLeft < 0) {
            popoverLeft = 0;
        }
        if (popoverLeft + SELECTION_POPOVER_WIDTH > window.innerWidth) {
            popoverLeft = window.innerWidth - SELECTION_POPOVER_WIDTH;
        }
    }
    var isScraped = !!scrapID;
    var handleScrapClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, selection, selectionText, startOffset, endOffset;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!currentUser) {
                        setShowLoginAlert(true);
                        return [
                            2
                        ];
                    }
                    if (!scrapID) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        coverLetterParagraphScrapDelete({
                            update: function(cache, param) {
                                var data = param.data;
                                var ref, ref1, ref2, ref3, ref4;
                                var coverLetterParagraphScrap = data === null || data === void 0 ? void 0 : (ref = data.coverLetterParagraphScrapDelete) === null || ref === void 0 ? void 0 : ref.coverLetterParagraphScrap;
                                var cachedCoverLetter = cache.readQuery({
                                    query: graphql/* CoverLetterDetailPageDocument */.ahc,
                                    variables: {
                                        id: coverLetterID,
                                        keyword: searchState.keyword
                                    }
                                });
                                var cachedViewerParagraphScraps = (cachedCoverLetter === null || cachedCoverLetter === void 0 ? void 0 : (ref1 = cachedCoverLetter.coverLetterWithHighlight) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.coverLetter) === null || ref2 === void 0 ? void 0 : ref2.viewerParagraphScraps) || [];
                                var newCachedViewerParagraphScraps = cachedViewerParagraphScraps.filter(function(scrap) {
                                    return scrap.id !== (coverLetterParagraphScrap === null || coverLetterParagraphScrap === void 0 ? void 0 : coverLetterParagraphScrap.id);
                                });
                                cache.writeQuery({
                                    query: graphql/* CoverLetterDetailPageDocument */.ahc,
                                    variables: {
                                        id: coverLetterID,
                                        keyword: searchState.keyword
                                    },
                                    data: {
                                        coverLetterWithHighlight: {
                                            coverLetter: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedCoverLetter === null || cachedCoverLetter === void 0 ? void 0 : (ref3 = cachedCoverLetter.coverLetterWithHighlight) === null || ref3 === void 0 ? void 0 : ref3.coverLetter), {
                                                viewerParagraphScraps: newCachedViewerParagraphScraps
                                            }),
                                            highlight: cachedCoverLetter === null || cachedCoverLetter === void 0 ? void 0 : (ref4 = cachedCoverLetter.coverLetterWithHighlight) === null || ref4 === void 0 ? void 0 : ref4.highlight,
                                            __typename: "CoverLetterWithHighlight"
                                        }
                                    }
                                });
                            },
                            variables: {
                                id: scrapID
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    selection = window.getSelection();
                    if (!selection) {
                        return [
                            2
                        ];
                    }
                    selectionText = ((ref1 = selection.getRangeAt) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(selection, 0)) === null || ref2 === void 0 ? void 0 : ref2.toString()) || "";
                    startOffset = coverLetterContent.indexOf(selectionText);
                    endOffset = startOffset + selectionText.length;
                    if (selectionText.length === 0) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        coverLetterParagraphScrapCreate({
                            update: function(cache, param) {
                                var data = param.data;
                                var ref, ref1, ref2, ref3, ref4;
                                var coverLetterParagraphScrap = data === null || data === void 0 ? void 0 : (ref = data.coverLetterParagraphScrapCreate) === null || ref === void 0 ? void 0 : ref.coverLetterParagraphScrap;
                                var cachedCoverLetter = cache.readQuery({
                                    query: graphql/* CoverLetterDetailPageDocument */.ahc,
                                    variables: {
                                        id: coverLetterID,
                                        keyword: searchState.keyword
                                    }
                                });
                                var cachedViewerParagraphScraps = (cachedCoverLetter === null || cachedCoverLetter === void 0 ? void 0 : (ref1 = cachedCoverLetter.coverLetterWithHighlight) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.coverLetter) === null || ref2 === void 0 ? void 0 : ref2.viewerParagraphScraps) || [];
                                var newCachedViewerParagraphScraps = (0,_to_consumable_array/* default */.Z)(cachedViewerParagraphScraps);
                                if (coverLetterParagraphScrap) {
                                    newCachedViewerParagraphScraps.push(coverLetterParagraphScrap);
                                }
                                cache.writeQuery({
                                    query: graphql/* CoverLetterDetailPageDocument */.ahc,
                                    variables: {
                                        id: coverLetterID,
                                        keyword: searchState.keyword
                                    },
                                    data: {
                                        coverLetterWithHighlight: {
                                            coverLetter: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedCoverLetter === null || cachedCoverLetter === void 0 ? void 0 : (ref3 = cachedCoverLetter.coverLetterWithHighlight) === null || ref3 === void 0 ? void 0 : ref3.coverLetter), {
                                                viewerParagraphScraps: newCachedViewerParagraphScraps
                                            }),
                                            highlight: cachedCoverLetter === null || cachedCoverLetter === void 0 ? void 0 : (ref4 = cachedCoverLetter.coverLetterWithHighlight) === null || ref4 === void 0 ? void 0 : ref4.highlight,
                                            __typename: "CoverLetterWithHighlight"
                                        }
                                    }
                                });
                                if (!currentUser.isCheckedParagraphScrapGuide) {
                                    var cachedCurrentUser = cache.readFragment({
                                        id: "User:".concat(currentUser.id),
                                        fragmentName: "CoverLetterItemMain_currentUser",
                                        fragment: graphql/* CoverLetterItemMain_CurrentUserFragmentDoc */.Iv8
                                    });
                                    cache.writeFragment({
                                        id: "User:".concat(currentUser.id),
                                        fragmentName: "CoverLetterItemMain_currentUser",
                                        fragment: graphql/* CoverLetterItemMain_CurrentUserFragmentDoc */.Iv8,
                                        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedCurrentUser), {
                                            isCheckedParagraphScrapGuide: true
                                        })
                                    });
                                }
                            },
                            variables: {
                                input: {
                                    coverLetterID: coverLetterID,
                                    referer: "/coverLetter/".concat(coverLetterID),
                                    startOffset: startOffset,
                                    endOffset: endOffset,
                                    paragraph: selectionText
                                }
                            }
                        })
                    ];
                case 3:
                    _state.sent();
                    enqueueSnackbar("문장스크랩 완료! 우측 상단의 스크랩 버튼 클릭시, 확인 가능합니다.");
                    _state.label = 4;
                case 4:
                    (ref = window.getSelection()) === null || ref === void 0 ? void 0 : ref.removeAllRanges();
                    closePopover();
                    return [
                        2
                    ];
            }
        });
    }), [
        coverLetterID,
        scrapID,
        searchState.keyword
    ]);
    var handleCopy = (0,react.useCallback)(function() {
        enqueueSnackbar("클립보드에 복사되었습니다.");
        closePopover();
    }, [
        closePopover,
        enqueueSnackbar
    ]);
    var passedAt = (0,utils_coverLetter/* getPassedAtText */.S)(coverLetter);
    var quote = "".concat((0,arrayFilterJoin/* default */.Z)([
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName,
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role,
        passedAt, 
    ]), " 합격자소서 문장입니다.");
    var kakaoShareText = "".concat(quote, "\n\n").concat(scrapedParagraph || (0,src_utils/* getSelectionText */.mR)());
    var handleShareClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var windowNavigator, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    windowNavigator = window.navigator;
                    if (!(windowNavigator && windowNavigator.share)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        windowNavigator.share({
                            title: quote,
                            text: kakaoShareText,
                            url: "https://".concat(linkareer, "/cover-letter/").concat(coverLetterID)
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    setShowShareModal(true);
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var closeLoginAlert = (0,react.useCallback)(function() {
        setShowLoginAlert(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
                isOpen: isOpen,
                left: popoverLeft,
                top: popoverTop,
                id: SELECTION_POPOVER_ID,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActionBtn, {
                                id: "selection-popover-scrap-btn",
                                isActive: isScraped,
                                onClick: handleScrapClick,
                                children: "문장 스크랩"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVerticalDivider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                text: getCopyText(scrapedParagraph),
                                onCopy: handleCopy,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActionBtn, {
                                    id: "selection-popover-copy-btn",
                                    children: "복사"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVerticalDivider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActionBtn, {
                                id: "selection-popover-share-btn",
                                onClick: handleShareClick,
                                children: "공유"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowDown, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "로그인 후",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrimaryText, {
                            color: "primary",
                            children: "스크랩이"
                        }),
                        " ",
                        "가능합니다."
                    ]
                }),
                DialogProps: {
                    open: showLoginAlert
                },
                onRequestClose: closeLoginAlert
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                title: "자소서 문장 공유",
                open: showShareModal,
                quote: quote,
                url: "https://".concat(linkareer, "/cover-letter/").concat(coverLetterID),
                kakaoShareProps: {
                    objectType: "text",
                    text: kakaoShareText
                },
                onModalClose: function() {
                    return setShowShareModal(false);
                }
            })
        ]
    });
};
/* harmony default export */ var CoverLetterDetailContent_SelectionPopover = (SelectionPopover);
var StyledRoot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionPopover__StyledRoot",
    componentId: "sc-5683a4c1-0"
})(SelectionPopover_templateObject(), function(props) {
    return props.isOpen ? 1 : 0;
}, function(props) {
    return "translate3d(".concat(props.left, "px, ").concat(props.top, "px, 0px)");
});
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionPopover__StyledActions",
    componentId: "sc-5683a4c1-1"
})(_templateObject1(), SELECTION_POPOVER_WIDTH, SELECTION_POPOVER_HEIGHT);
var StyledActionBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SelectionPopover__StyledActionBtn",
    componentId: "sc-5683a4c1-2"
})(_templateObject2(), function(props) {
    return props.isActive ? "#01A0FF" : "#fff";
});
var StyledVerticalDivider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    displayName: "SelectionPopover__StyledVerticalDivider",
    componentId: "sc-5683a4c1-3"
})(_templateObject3());
var StyledArrowDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionPopover__StyledArrowDown",
    componentId: "sc-5683a4c1-4"
})(_templateObject4());
var StyledPrimaryText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SelectionPopover__StyledPrimaryText",
    componentId: "sc-5683a4c1-5"
})(_templateObject5());
function getCopyText(defaultText) {
    var selectionText = (0,src_utils/* getSelectionText */.mR)();
    return "".concat(defaultText || selectionText, "\n\n\n").concat(config/* COPY_SUFFIX */.jk);
}

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/content-node/ScrapHighlightNode.tsx

function ScrapHighlightNode_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ffcccc;\n  cursor: pointer;\n"
    ]);
    ScrapHighlightNode_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ScrapHighlightNode = function(param) {
    var children = param.children, node = param.node;
    var markRef = (0,react.useRef)(null);
    var openPopover = useSelectionPopoverContext().openPopover;
    var handleClick = function() {
        var mark = markRef.current;
        if (!mark) {
            return;
        }
        var rect = mark.getBoundingClientRect();
        openPopover({
            selectionRect: rect,
            scrapID: node.id,
            selectionText: mark.innerText
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMark, {
        ref: markRef,
        onClick: handleClick,
        children: children
    });
};
var StyledMark = styled_components_browser_esm/* default.mark.withConfig */.ZP.mark.withConfig({
    displayName: "ScrapHighlightNode__StyledMark",
    componentId: "sc-b07ce9fb-0"
})(ScrapHighlightNode_templateObject());
function buildScrapHighlightNode(id, childrenNodeList) {
    return {
        id: id,
        type: CoverLetterNodeType.COMPONENT,
        wrapper: "ScrapHighlightNode",
        childrenNodeList: childrenNodeList
    };
}

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/content-node/SearchKeywordHighlightNode.tsx

function SearchKeywordHighlightNode_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  background-color: #bbe6ff;\n"
    ]);
    SearchKeywordHighlightNode_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SearchKeywordHighlightNode = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledB, {
        children: children
    });
};
var StyledB = styled_components_browser_esm/* default.b.withConfig */.ZP.b.withConfig({
    displayName: "SearchKeywordHighlightNode__StyledB",
    componentId: "sc-81f7b1f-0"
})(SearchKeywordHighlightNode_templateObject());
function buildSearchKeywordHighlightNode(id, childrenNodeList) {
    return {
        id: id,
        type: CoverLetterNodeType.COMPONENT,
        wrapper: "SearchKeywordHighlightNode",
        childrenNodeList: childrenNodeList
    };
}

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/content-node/index.ts




var CoverLetterNodeType;
(function(CoverLetterNodeType) {
    CoverLetterNodeType[CoverLetterNodeType["COMPONENT"] = 0] = "COMPONENT";
    CoverLetterNodeType[CoverLetterNodeType["NATIVE_NODE"] = 1] = "NATIVE_NODE";
    CoverLetterNodeType[CoverLetterNodeType["TEXT_NODE"] = 2] = "TEXT_NODE";
})(CoverLetterNodeType || (CoverLetterNodeType = {}));
function getCoverLetterContentWrapperComponentByName(name) {
    switch(name){
        case "ScrapHighlightNode":
            {
                return ScrapHighlightNode;
            }
        case "SearchKeywordHighlightNode":
            {
                return SearchKeywordHighlightNode;
            }
        default:
            {
                return null;
            }
    }
}
function buildTextNode(id, text) {
    return {
        id: id,
        type: CoverLetterNodeType.TEXT_NODE,
        childrenNodeList: [],
        text: text
    };
}

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/libs/highlightNodes.ts







var getTagOffsetList = function(source, tag) {
    var sourceClone = source;
    var TAG_LENGTH = tag.length;
    if (!tag || !(0,src_utils/* isTag */.YR)(tag)) {
        return [];
    }
    var endTag = (0,src_utils/* getCloseTagOf */.$G)(tag);
    var index = 0;
    var tagOffsetList = [];
    while(sourceClone.indexOf(tag) !== -1){
        var startOffset = sourceClone.indexOf(tag);
        var endOffset = sourceClone.indexOf(endTag) - TAG_LENGTH;
        tagOffsetList.push({
            id: index.toString(),
            startOffset: startOffset,
            endOffset: endOffset
        });
        sourceClone = sourceClone.replace(tag, "");
        sourceClone = sourceClone.replace(endTag, "");
        index = index + 1;
    }
    return tagOffsetList;
};
/**
 * 범위를 기준으로 텍스트를 연속된 덩어리(run)로 분할합니다.
 * 각 run은 하나의 노드로 렌더링되어 React 주석 문제를 방지합니다.
 */ var splitIntoRuns = function(content, scraps, keywords) {
    var _loop = function(i) {
        var start = sortedBoundaries[i];
        var end = sortedBoundaries[i + 1];
        if (start >= end) return "continue";
        // 이 run이 어떤 하이라이트에 속하는지 확인
        var scrap = scraps.find(function(param) {
            var startOffset = param.startOffset, endOffset = param.endOffset;
            return startOffset <= start && end <= endOffset;
        });
        var keyword = keywords.find(function(param) {
            var startOffset = param.startOffset, endOffset = param.endOffset;
            return startOffset <= start && end <= endOffset;
        });
        runs.push({
            start: start,
            end: end,
            scrap: scrap,
            keyword: keyword
        });
    };
    var runs = [];
    var contentLength = content.length;
    // 모든 범위의 경계점을 수집 (시작점과 끝점)
    var boundaries = new Set([
        0,
        contentLength
    ]);
    scraps.forEach(function(param) {
        var startOffset = param.startOffset, endOffset = param.endOffset;
        boundaries.add(startOffset);
        boundaries.add(endOffset);
    });
    keywords.forEach(function(param) {
        var startOffset = param.startOffset, endOffset = param.endOffset;
        boundaries.add(startOffset);
        boundaries.add(endOffset);
    });
    // 경계점을 정렬
    var sortedBoundaries = Array.from(boundaries).sort(function(a, b) {
        return a - b;
    });
    // 각 경계점 사이를 하나의 run으로 생성
    for(var i = 0; i < sortedBoundaries.length - 1; i++)_loop(i);
    return runs;
};
var buildCoverLetterNodes = function(source) {
    var content = source.content, scraps = source.scraps, keywords = source.keywords;
    // 텍스트를 연속된 덩어리(run)로 분할
    var runs = splitIntoRuns(content, scraps, keywords);
    var nodes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = runs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var run = _step.value;
            var runText = content.substring(run.start, run.end);
            if (runText.length === 0) {
                continue;
            }
            var textNode = buildTextNode("".concat(run.start, "-").concat(run.end), runText);
            var currentNode = textNode;
            if (run.keyword) {
                currentNode = buildSearchKeywordHighlightNode(run.keyword.id, [
                    currentNode, 
                ]);
            }
            if (run.scrap) {
                currentNode = buildScrapHighlightNode(run.scrap.id, [
                    currentNode
                ]);
            }
            var lastNode = nodes[nodes.length - 1];
            if (lastNode && lastNode.id === currentNode.id && lastNode.type === currentNode.type && lastNode.wrapper === currentNode.wrapper) {
                var _childrenNodeList;
                (_childrenNodeList = lastNode.childrenNodeList).push.apply(_childrenNodeList, (0,_to_consumable_array/* default */.Z)(currentNode.childrenNodeList));
            } else {
                nodes.push(currentNode);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return nodes;
};
var isScrapValid = function() {
    var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", scrap = arguments.length > 1 ? arguments[1] : void 0;
    var extractedContent = source.substring(scrap.startOffset, scrap.endOffset);
    return extractedContent === scrap.paragraph;
};
var getRangeBoundingClientRect = function(range) {
    var rects = range.getClientRects();
    if (rects.length < 1) {
        return null;
    }
    var initialRect = rects[0];
    var position = {
        left: initialRect.left,
        top: initialRect.top,
        right: initialRect.right,
        bottom: initialRect.bottom,
        width: 0,
        height: 0
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Array.from(rects)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rect = _step.value;
            if (position.left > rect.left) {
                position.left = rect.left;
            }
            if (position.top > rect.top) {
                position.top = rect.top;
            }
            if (position.right < rect.right) {
                position.right = rect.right;
            }
            if (position.bottom < rect.bottom) {
                position.bottom = rect.bottom;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, position), {
        width: position.right - position.left,
        height: position.bottom - position.top
    });
};
var renderCoverLetterContent = function(node) {
    switch(node.type){
        case CoverLetterNodeType.TEXT_NODE:
            {
                return node.text || "";
            }
        case CoverLetterNodeType.COMPONENT:
            {
                if (!node.wrapper) {
                    return "error";
                }
                var wrapperComponent = getCoverLetterContentWrapperComponentByName(node.wrapper);
                var childrenNode = node.childrenNodeList.map(function(childrenNode) {
                    return renderCoverLetterContent(childrenNode);
                });
                return (0,react.createElement)(wrapperComponent, {
                    key: node.id,
                    node: node
                }, childrenNode);
            }
        case CoverLetterNodeType.NATIVE_NODE:
            {
                if (!node.wrapper) {
                    return "error";
                }
                if (!(0,src_utils/* isValidTag */.wb)(node.wrapper)) {
                    return "error";
                }
                var childrenNode1 = node.childrenNodeList.map(function(childrenNode) {
                    return renderCoverLetterContent(childrenNode);
                });
                return (0,react.createElement)(node.wrapper, null, childrenNode1);
            }
        default:
            {
                return "error";
            }
    }
};
var highlightNodes_getCopyText = function(defaultText) {
    var selectionText = getSelectionText();
    return "".concat(defaultText || selectionText, "\n\n\n").concat(COPY_SUFFIX);
};

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/CoverLetterDetailContent.tsx



function CoverLetterDetailContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.43;\n  letter-spacing: 0.01071em;\n  font-size: 16px;\n  font-weight: normal;\n  text-align: left;\n  line-height: 2.13;\n  letter-spacing: -0.64px;\n  white-space: pre-line;\n  margin-bottom: 50px;\n  position: relative;\n  padding-top: 25px;\n"
    ]);
    CoverLetterDetailContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var CoverLetterDetailContent = function(param) {
    var currentUser = param.currentUser, coverLetter = param.coverLetter, highlight = param.highlight;
    var rootRef = (0,react.useRef)(null);
    var ref = useSelectionPopoverContext(), closePopover = ref.closePopover, openPopover = ref.openPopover;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref1;
    var originalContent = (ref1 = coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.content) !== null && ref1 !== void 0 ? ref1 : "";
    var viewerParagraphScraps = (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.viewerParagraphScraps) || [];
    var validScraps = viewerParagraphScraps.reduce(function(validScraps, scrap) {
        var id = scrap.id, startOffset = scrap.startOffset, endOffset = scrap.endOffset, paragraph = scrap.paragraph;
        if (isScrapValid(originalContent, {
            startOffset: startOffset,
            endOffset: endOffset,
            paragraph: paragraph
        })) {
            validScraps.push({
                id: id,
                startOffset: startOffset,
                endOffset: endOffset,
                paragraph: paragraph
            });
            return validScraps;
        }
        var newStartOffset = originalContent.indexOf(paragraph);
        if (newStartOffset === -1) {
            return validScraps;
        }
        var newEndOffset = newStartOffset + paragraph.length;
        validScraps.push({
            id: id,
            startOffset: newStartOffset,
            endOffset: newEndOffset,
            paragraph: paragraph
        });
        return validScraps;
    }, []);
    var searchKeywords = getTagOffsetList(highlight || "", "<b>");
    var nodes = buildCoverLetterNodes({
        content: originalContent,
        scraps: validScraps,
        keywords: searchKeywords
    });
    var handleMouseUp = function(e) {
        if (common/* IS_SERVER */.W) {
            return;
        }
        var selection = window.getSelection();
        var target = e.target;
        if (!(0,_instanceof/* default */.Z)(target, HTMLElement)) {
            return;
        }
        var clickedTargetID = target.id;
        if (SelectionPopoverActionIDs.includes(clickedTargetID)) {
            e.stopPropagation();
            return;
        }
        if (!(selection === null || selection === void 0 ? void 0 : selection.rangeCount)) {
            closePopover();
            return;
        }
        var selectionString = selection.toString();
        if (selectionString.length === 0) {
            closePopover();
            return;
        }
        if (selectionString.length < 5) {
            enqueueSnackbar("스크랩은 최소 5문자부터 가능합니다.");
            closePopover();
            return;
        }
        var range = selection.getRangeAt(0);
        var position = getRangeBoundingClientRect(range);
        if (!position) {
            return;
        }
        openPopover({
            selectionText: (0,src_utils/* getSelectionText */.mR)(),
            selectionRect: position
        });
    };
    var handleMouseLeave = function() {
        closePopover();
    };
    var getMainCoordinates = (0,react.useCallback)(function() {
        var ref;
        if (common/* IS_SERVER */.W) {
            return undefined;
        }
        return (ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMain, {
        ref: rootRef,
        onMouseUp: handleMouseUp,
        onMouseLeave: handleMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterDetailContent_SelectionPopover, {
                currentUser: currentUser,
                coverLetter: coverLetter,
                getBaseCoordinates: getMainCoordinates
            }),
            nodes.map(function(node) {
                return renderCoverLetterContent(node);
            })
        ]
    });
};
var CoverLetterDetailContentContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionPopoverProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterDetailContent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var CoverLetterDetailContent_CoverLetterDetailContent = (CoverLetterDetailContentContainer);
var StyledMain = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CoverLetterDetailContent__StyledMain",
    componentId: "sc-62b7bc08-0"
})(CoverLetterDetailContent_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/index.ts



// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js
var useCookies = __webpack_require__(12102);
// EXTERNAL MODULE: ./src/svgIcons/CloseOutlined.tsx
var CloseOutlined = __webpack_require__(57065);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailContent/SelectionGuideBar.tsx




function SelectionGuideBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: #eee;\n  padding: 15px 20px;\n\n  ",
        " {\n    padding: 21px 20px;\n  }\n"
    ]);
    SelectionGuideBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectionGuideBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n\n  ",
        " {\n    justify-content: space-around;\n  }\n"
    ]);
    SelectionGuideBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectionGuideBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #333;\n  margin-top: 15px;\n\n  ",
        " {\n    margin-top: 0;\n    margin-right: 15px;\n  }\n"
    ]);
    SelectionGuideBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectionGuideBar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  line-height: 1.38;\n  font-size: 16px;\n"
    ]);
    SelectionGuideBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectionGuideBar_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.47;\n  font-size: 15px;\n  padding-top: 10px;\n"
    ]);
    SelectionGuideBar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectionGuideBar_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  background-color: #ffcccc;\n"
    ]);
    SelectionGuideBar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n  background-color: transparent;\n  outline: 0;\n  border: 0;\n  margin: 0;\n  border-radius: 0;\n  padding: 0;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  text-decoration: none;\n  color: inherit;\n  border-radius: 50%;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n\n  &:disabled {\n    pointer-events: none;\n    cursor: default;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #333;\n  width: 21px;\n  height: 21px;\n  font-size: 25px;\n\n  path {\n    fill: #333;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  padding-top: 11px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #999;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







var NEVER_SEEING_PARAGRAPH_SCRAP_GUIDE_AGAINE_COOKIE_NAME = "naver_seeing_paragraph_scrap_guide_again_cookie";
var SelectionGuideBar = function(param) {
    var currentUser = param.currentUser;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)(), 2), cookies = ref[0], setCookies = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useViewerCheckedParagraphScrapGuideMutation */.w0B)(), 1), viewerCheckedParagraphScrapGuide = ref1[0];
    var openParagraphScrapGuide = !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isCheckedParagraphScrapGuide);
    var hasNeverSeeingParagraphScrapGuideAgainCookie = !!(cookies === null || cookies === void 0 ? void 0 : cookies[NEVER_SEEING_PARAGRAPH_SCRAP_GUIDE_AGAINE_COOKIE_NAME]);
    if (hasNeverSeeingParagraphScrapGuideAgainCookie) {
        openParagraphScrapGuide = false;
    }
    var handleCloseClick = (0,react.useCallback)(function() {
        setCookies(NEVER_SEEING_PARAGRAPH_SCRAP_GUIDE_AGAINE_COOKIE_NAME, true);
    }, []);
    var handlePermanantCloseClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!currentUser) {
                        setCookies(NEVER_SEEING_PARAGRAPH_SCRAP_GUIDE_AGAINE_COOKIE_NAME, true);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        viewerCheckedParagraphScrapGuide()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: openParagraphScrapGuide && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectionGuideBar_StyledRoot, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMainWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectionGuideBar_StyledMain, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitle, {
                                    children: [
                                        "마음에 드는 문장을 스크랩 할 수 있어요!",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenMdUp, {
                                            children: "지금 바로 PC에서 이용해보세요."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenSmDown, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExample, {
                                        children: [
                                            "최고 품질의 상품들을",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlight, {
                                                children: "지금보다 더 많은 소비자들이 여러 유통 채널에서 더욱 폭 넓고 쉽게"
                                            }),
                                            "..."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenSmDown, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                                onClick: handleCloseClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseIcon, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenMdUp, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                                onClick: handlePermanantCloseClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseIcon, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenSmDown, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHideBtn, {
                            onClick: handlePermanantCloseClick,
                            children: "다시보지 않기"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CoverLetterDetailContent_SelectionGuideBar = (SelectionGuideBar);
var tabletBreakPoint = "@media (min-width: 960px)";
var SelectionGuideBar_StyledRoot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionGuideBar__StyledRoot",
    componentId: "sc-f85da30b-0"
})(SelectionGuideBar_templateObject(), media/* mobileBreakPoint */.vm);
var StyledMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionGuideBar__StyledMainWrap",
    componentId: "sc-f85da30b-1"
})(SelectionGuideBar_templateObject1(), media/* mobileBreakPoint */.vm);
var SelectionGuideBar_StyledMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionGuideBar__StyledMain",
    componentId: "sc-f85da30b-2"
})(SelectionGuideBar_templateObject2(), media/* mobileBreakPoint */.vm);
var StyledTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionGuideBar__StyledTitle",
    componentId: "sc-f85da30b-3"
})(SelectionGuideBar_templateObject3());
var StyledExample = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "SelectionGuideBar__StyledExample",
    componentId: "sc-f85da30b-4"
})(SelectionGuideBar_templateObject4());
var StyledHighlight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SelectionGuideBar__StyledHighlight",
    componentId: "sc-f85da30b-5"
})(SelectionGuideBar_templateObject5());
var StyledIconButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SelectionGuideBar__StyledIconButton",
    componentId: "sc-f85da30b-6"
})(_templateObject6());
var StyledCloseIcon = (0,styled_components_browser_esm/* default */.ZP)(CloseOutlined/* default */.Z).withConfig({
    displayName: "SelectionGuideBar__StyledCloseIcon",
    componentId: "sc-f85da30b-7"
})(_templateObject7());
var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    displayName: "SelectionGuideBar__StyledFooter",
    componentId: "sc-f85da30b-8"
})(_templateObject8());
var StyledHideBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SelectionGuideBar__StyledHideBtn",
    componentId: "sc-f85da30b-9"
})(_templateObject9());
var HiddenSmDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionGuideBar__HiddenSmDown",
    componentId: "sc-f85da30b-10"
})(_templateObject10(), media/* mobileBreakPoint */.vm);
var HiddenMdUp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectionGuideBar__HiddenMdUp",
    componentId: "sc-f85da30b-11"
})(_templateObject11(), tabletBreakPoint);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/screen/rightSection/menus/CoverLetterSearch/store/coverLetter.ts
var store_coverLetter = __webpack_require__(479);
// EXTERNAL MODULE: ./src/hooks/useErrorSnackbar.ts
var useErrorSnackbar = __webpack_require__(96597);
// EXTERNAL MODULE: ./src/hooks/useKeywordHighlighter.ts
var useKeywordHighlighter = __webpack_require__(17683);
// EXTERNAL MODULE: ./src/svgIcons/Share.tsx
var Share = __webpack_require__(1651);
;// CONCATENATED MODULE: ./src/svgIcons/WriteCoverLetterIcon.tsx



var WriteCoverLetter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.998",
        height: "14.924",
        viewBox: "0 0 14.998 14.924"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            "data-name": "그룹 33845",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "data-name": "그룹 16095",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "data-name": "그룹 15920",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            "data-name": "사각형 12761",
                            style: {
                                fill: "none"
                            },
                            d: "M0 0h14.924v14.924H0z",
                            transform: "translate(.074)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "data-name": "그룹 16016",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "data-name": "그룹 15988",
                            transform: "translate(0 .043)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    "data-name": "사각형 1518",
                                    width: "6.928",
                                    height: "1.879",
                                    rx: ".94",
                                    transform: "translate(8.069 11.972)",
                                    style: {
                                        fill: "#01a0ff"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    "data-name": "사각형 1518 - 윤곽선",
                                    d: "M.94.9a.044.044 0 1 0 0 .089h5.048a.044.044 0 1 0 0-.089H.94m0-.9h5.048a.94.94 0 0 1 0 1.879H.94A.94.94 0 1 1 .94 0z",
                                    transform: "translate(8.069 11.972)",
                                    style: {
                                        fill: "#01a0ff"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    "data-name": "패스 8448",
                                    d: "M0 0h3.852v1.879H0z",
                                    transform: "rotate(45 1.413 11.872)",
                                    style: {
                                        fill: "#01a0ff"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    "data-name": "패스 8449",
                                    d: "M7852.717-17977.02h-3.277a.746.746 0 0 1-.747-.746v-3.406a.749.749 0 0 1 .219-.527l9.28-9.277a.746.746 0 0 1 1.055 0l3.337 3.338a.748.748 0 0 1 0 1.057l-9.34 9.342a.737.737 0 0 1-.527.219zm-2.531-1.492h2.221l8.595-8.6-2.282-2.283-8.534 8.533z",
                                    transform: "translate(-7848.694 17991.195)",
                                    style: {
                                        fill: "#01a0ff"
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var WriteCoverLetterIcon = (WriteCoverLetter);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/esm/zonedTimeToUtc/index.js + 4 modules
var zonedTimeToUtc = __webpack_require__(43986);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterWriteTooltip.tsx


function CoverLetterWriteTooltip_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  > .tooltip {\n    top: calc(100% + 15px);\n    display: flex;\n    align-items: center;\n    position: absolute;\n    min-width: max-content;\n    padding: 15px;\n    background-color: #2a22fc;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 1.38;\n    letter-spacing: -0.64px;\n    color: #fff;\n    gap: 10px;\n\n    > i > svg {\n      display: block;\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n      fill: #fff;\n    }\n\n    &::before {\n      border-color: #2a22fc transparent;\n      border-style: solid;\n      border-width: 0 6px 8px 6.5px;\n      margin-left: -5px;\n      content: '';\n      display: block;\n      left: 5%;\n      position: absolute;\n      top: -8px;\n      width: 0;\n      z-index: 0;\n    }\n  }\n"
    ]);
    CoverLetterWriteTooltip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var COVER_LETTER_WRITE_TOOLTIP_COOKIE_NAME = "lnkr_cover_letter_write_tooltip";
var CoverLetterWriteTooltip = function(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)(), 2), cookies = ref[0], setCookie = ref[1];
    var ref1 = (0,react.useState)(!(cookies === null || cookies === void 0 ? void 0 : cookies[COVER_LETTER_WRITE_TOOLTIP_COOKIE_NAME])), openTooltip = ref1[0], setOpenTooltip = ref1[1];
    var isMobile = (0,useIsMobile/* default */.Z)();
    var getCookieDomain = function() {
        var url = window.location.href;
        if (url.includes("linkareer")) return ".linkareer.com";
        if (url.includes("lnkr")) return ".lnkr.cc";
        return "localhost";
    };
    var handleSetCookie = function(expiresDate) {
        setCookie(COVER_LETTER_WRITE_TOOLTIP_COOKIE_NAME, Date.now(), {
            expires: expiresDate,
            domain: getCookieDomain(),
            path: "/"
        });
    };
    var handleNoViewingForWeek = function() {
        var after7Days = (0,zonedTimeToUtc/* default */.Z)((0,addDays/* default */.Z)(new Date(), 7), config/* TIMEZONE */.aB);
        handleSetCookie(after7Days);
        setOpenTooltip(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverLetterWriteTooltip_StyledWrapper, {
        children: [
            children,
            !isMobile && openTooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tooltip",
                children: [
                    "보고있는 합격자소서 참고해서 내 자소서 작성하기",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        onClick: handleNoViewingForWeek,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterWriteTooltip = (CoverLetterWriteTooltip);
var CoverLetterWriteTooltip_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterWriteTooltip__StyledWrapper",
    componentId: "sc-9d893cf5-0"
})(CoverLetterWriteTooltip_templateObject());

// EXTERNAL MODULE: ./src/svgIcons/ArrowLeft.tsx
var ArrowLeft = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/svgIcons/NewWindow.tsx
var NewWindow = __webpack_require__(60784);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/NewWindowAndBackButton.tsx

function NewWindowAndBackButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  display: flex;\n  justify-content: flex-end;\n  min-width: 130px;\n\n  &.hidden {\n    display: none;\n  }\n\n  .icon-button-wrapper {\n    display: flex;\n    align-items: center;\n\n    &:first-child {\n      margin-right: 30px;\n    }\n  }\n\n  .icon-button {\n    color: #333;\n    margin-right: 10px;\n    background-color: #eee;\n\n    &:hover {\n      background-color: #ddd;\n    }\n  }\n"
    ]);
    NewWindowAndBackButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewWindowAndBackButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    NewWindowAndBackButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewWindowAndBackButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n  background-color: transparent;\n  outline: 0;\n  border: 0;\n  margin: 0;\n  border-radius: 0;\n  padding: 12px;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  text-decoration: none;\n  color: inherit;\n  border-radius: 50%;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n\n  &:disabled {\n    pointer-events: none;\n    cursor: default;\n  }\n"
    ]);
    NewWindowAndBackButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var addSimpleParamToUrl = function(url) {
    if (url.includes("?")) {
        return "".concat(url, "&simple=true");
    }
    var pathOnly = url.split("&")[0];
    return "".concat(pathOnly, "?simple=true");
};
var NewWindowAndBackButton = function(param) {
    var backButtonLink = param.backButtonLink, isSimplePage = param.isSimplePage;
    var router = (0,next_router.useRouter)();
    var linkareer = (0,src_context/* useDomain */.ay)().linkareer;
    var simplifiedUrl = "//".concat(linkareer).concat(addSimpleParamToUrl(router.asPath));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewWindowAndBackButton_HiddenSmDown, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewWindowAndBackButton_StyledWrapper, {
            className: isSimplePage ? "hidden" : "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "icon-button-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewWindowAndBackButton_StyledIconButton, {
                            as: "a",
                            id: "open-cover-letter-in-new-tab-btn",
                            className: "icon-button",
                            href: simplifiedUrl,
                            target: "_blank",
                            rel: "noopener",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewWindow/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "새창"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "icon-button-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewWindowAndBackButton_StyledIconButton, {
                            as: "a",
                            id: "back-to-cover-letter-list-btn",
                            className: "icon-button",
                            href: backButtonLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "목록"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CoverLetterItemScreen_NewWindowAndBackButton = (NewWindowAndBackButton);
var NewWindowAndBackButton_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewWindowAndBackButton__StyledWrapper",
    componentId: "sc-c93cd45d-0"
})(NewWindowAndBackButton_templateObject());
var NewWindowAndBackButton_HiddenSmDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewWindowAndBackButton__HiddenSmDown",
    componentId: "sc-c93cd45d-1"
})(NewWindowAndBackButton_templateObject1(), media/* mobileBreakPoint */.vm);
var NewWindowAndBackButton_StyledIconButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "NewWindowAndBackButton__StyledIconButton",
    componentId: "sc-c93cd45d-2"
})(NewWindowAndBackButton_templateObject2());

// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/svgIcons/BookMark.tsx
var BookMark = __webpack_require__(49123);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterScrap.tsx
var CoverLetterScrap = __webpack_require__(41678);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/PopperWithArrow.tsx

function PopperWithArrow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: ",
        ";\n  margin-top: 8px;\n  z-index: 1;\n  ",
        " {\n    right: 0;\n  }\n\n  .arrow-wrapper {\n    position: relative;\n    width: 0;\n    left: 30px;\n    border-right: solid 5px transparent;\n    border-left: solid 5px transparent;\n    border-bottom: solid 8px #ccc;\n    ",
        " {\n      position: absolute;\n      top: -8px;\n      right: 80px;\n      left: unset;\n    }\n  }\n\n  .arrow {\n    position: absolute;\n    top: 2px;\n    left: -5px !important;\n    width: 0;\n    border-right: solid 5px transparent;\n    border-left: solid 5px transparent;\n    border-bottom: solid 8px white;\n    border-radius: 5px;\n  }\n\n  .popper-children {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 20px;\n    background-color: white;\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n  }\n"
    ]);
    PopperWithArrow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PopperWithArrow = function(param) {
    var anchorEl = param.anchorEl, children = param.children, open = param.open, id = param.id;
    var ref = (0,react.useState)(open), openPopper = ref[0], setOpenPopper = ref[1];
    var popperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setOpenPopper(open);
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (popperRef.current && !popperRef.current.contains(event.target) && anchorEl && !anchorEl.contains(event.target)) {
                setOpenPopper(false);
            }
        };
        if (openPopper) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        anchorEl,
        openPopper
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopperWithArrow_StyledWrapper, {
        id: id,
        ref: popperRef,
        isOpen: openPopper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "arrow-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "arrow"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "popper-children",
                children: children
            })
        ]
    });
};
/* harmony default export */ var CoverLetterItemScreen_PopperWithArrow = (PopperWithArrow);
var PopperWithArrow_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PopperWithArrow__StyledWrapper",
    componentId: "sc-fe47f75-0"
})(PopperWithArrow_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/ScrapButtonWithPopper.tsx

function ScrapButtonWithPopper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .link {\n    text-decoration: underline;\n  }\n\n  .scrap-alarm {\n    font-weight: normal;\n    padding-bottom: 10px;\n  }\n"
    ]);
    ScrapButtonWithPopper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScrapButtonWithPopper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: #666666;\n  border: 1px solid #cccccc;\n  background-color: #fff;\n  display: flex;\n  min-width: 120px;\n  height: 50px;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  border-radius: 5px;\n  font-size: 16px;\n  box-sizing: border-box;\n  font-weight: bold;\n  line-height: 1.5;\n\n  ",
        " {\n    padding: 0px 15px;\n    min-width: 50px;\n    gap: 0;\n  }\n\n  &[data-is-on='true'] {\n    color: #01a0ff;\n    border-color: #cccccc; /* 스크랩된 상태에서도 회색 테두리 유지 */\n  }\n\n  > .bookmark-icon {\n    color: inherit; /* 부모의 color 속성을 상속받도록 변경 */\n    width: 12px;\n    height: 16px;\n    flex-shrink: 0;\n  }\n"
    ]);
    ScrapButtonWithPopper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ScrapButtonWithPopper_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ScrapButtonWithPopper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var ScrapButtonWithPopper = function(param) {
    var coverLetter = param.coverLetter, currentUser = param.currentUser;
    var ref = (0,react.useState)(false), openScrapPopper = ref[0], setOpenScrapPopper = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var id = openScrapPopper ? "cover-letter-transitions-popper" : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapButtonWithPopper_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScrap/* default */.Z, {
            coverLetter: coverLetter,
            currentUser: currentUser,
            children: function(param) {
                var scrapCoverLetter = param.scrapCoverLetter, loading = param.loading;
                var handleClick = function(event) {
                    scrapCoverLetter();
                    setOpenScrapPopper(!!currentUser && !(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped));
                    setAnchorEl(event.currentTarget);
                    setTimeout(function() {
                        setOpenScrapPopper(false);
                    }, 5000);
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledScrapButton, {
                            onClick: handleClick,
                            disabled: loading,
                            "data-is-on": coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
                                    isOn: !!(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped),
                                    className: "bookmark-icon",
                                    strokeType: "#666666"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonText, {
                                    children: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? "스크랩완료" : "스크랩하기"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverLetterItemScreen_PopperWithArrow, {
                            open: openScrapPopper,
                            anchorEl: anchorEl,
                            id: id,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "scrap-alarm",
                                    children: "해당 자소서가 스크랩 페이지에 저장됐습니다."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/accounts/scrap?p=1&tab=COVER_LETTER_AND_PARAGRAPH",
                                    className: "link",
                                    children: "스크랩 페이지 확인"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var CoverLetterItemScreen_ScrapButtonWithPopper = (ScrapButtonWithPopper);
var ScrapButtonWithPopper_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrapButtonWithPopper__StyledWrapper",
    componentId: "sc-b834d256-0"
})(ScrapButtonWithPopper_templateObject());
var StyledScrapButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ScrapButtonWithPopper__StyledScrapButton",
    componentId: "sc-b834d256-1"
})(ScrapButtonWithPopper_templateObject1(), media/* mobileBreakPoint */.vm);
var StyledButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ScrapButtonWithPopper__StyledButtonText",
    componentId: "sc-b834d256-2"
})(ScrapButtonWithPopper_templateObject2(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetailInfo.tsx




function CoverLetterDetailInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  .header-info {\n    font-size: 16px;\n    font-weight: bold;\n    color: #01a0ff;\n  }\n\n  .basic-info {\n    font-size: 24px;\n    font-weight: normal;\n    letter-spacing: -1.2px;\n    margin-bottom: 10px;\n    & .highlight {\n      font-weight: 600;\n    }\n    ",
        " {\n      letter-spacing: -0.96px;\n    }\n  }\n\n  .spec-info {\n    font-size: 16px;\n    font-weight: normal;\n    letter-spacing: -0.8px;\n    margin-bottom: 30px;\n    ",
        " {\n      letter-spacing: -0.64px;\n    }\n  }\n\n  .button {\n    min-height: 50px;\n  }\n\n  .margin-right {\n    margin-right: 10px;\n  }\n\n  .button-wrapper {\n    display: flex;\n    height: 50px;\n    margin-bottom: 30px;\n    justify-content: space-between;\n    ",
        " {\n      margin-bottom: 40px;\n      justify-content: center;\n    }\n\n    .button-wrapper-inner {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      .cover-letter-write,\n      .cover-letter-share {\n        transition: all 0.2s;\n        cursor: pointer;\n        color: #666666;\n        border: 1px solid #cccccc;\n        background-color: #fff;\n        gap: 10px;\n        display: flex;\n        min-width: 120px;\n        height: 50px;\n        align-items: center;\n        justify-content: center;\n        border-radius: 5px;\n        font-size: 16px;\n        box-sizing: border-box;\n        font-weight: bold;\n        line-height: 1.5;\n        border-radius: 5px;\n      }\n      .cover-letter-write {\n        min-width: 130px;\n        color: #01a0ff;\n        border: 1px solid #01a0ff;\n        &:hover {\n          background-color: #f2faff;\n        }\n      }\n\n      ",
        " {\n        width: 100%;\n        > .cover-letter-write {\n          width: 100%;\n        }\n        > .cover-letter-share {\n          ",
        " {\n            min-width: 0;\n            padding: 0px 15px;\n            width: 50px;\n            flex-shrink: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .new-back-button-wrapper {\n    display: flex;\n  }\n"
    ]);
    CoverLetterDetailInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CoverLetterDetailInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    width: 100%;\n\n    > .cover-letter-write {\n      width: 100%;\n    }\n  }\n"
    ]);
    CoverLetterDetailInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CoverLetterDetailInfo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    CoverLetterDetailInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CoverLetterDetailInfo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    CoverLetterDetailInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CoverLetterDetailInfo_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterDetailInfo_currentUser on User {\n    ...CoverLetterScrap_currentUser\n  }\n  fragment CoverLetterDetailInfo_coverLetter on CoverLetter {\n    id\n    role\n    content\n    organizationName\n    viewerParagraphScraps {\n      id\n      startOffset\n      endOffset\n      paragraph\n    }\n    ...CoverLetterUtils_getSpecInfo_coverLetter\n    ...CoverLetterUtils_getPassedAtText_coverLetter\n  }\n"
    ]);
    CoverLetterDetailInfo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





















var CoverLetterDetailInfo = function(param) {
    var _isSimplePage = param.isSimplePage, isSimplePage = _isSimplePage === void 0 ? false : _isSimplePage, coverLetter = param.coverLetter, currentUser = param.currentUser, listLink = param.listLink;
    var router = (0,next_router.useRouter)();
    var linkareer = (0,src_context/* useDomain */.ay)().linkareer;
    var ref = (0,react.useState)(false), openShareModal = ref[0], setOpenShareModal = ref[1];
    var enqueueApolloError = (0,useErrorSnackbar/* default */.Z)().enqueueApolloError;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateSelfIntroductionMutation */.vUq)({
        onError: enqueueApolloError
    }), 1), createSelfIntroduction = ref1[0];
    var setCoverLetterId = (0,store_coverLetter/* useCoverLetterStore */.t)(function(state) {
        return state.setCoverLetterId;
    });
    var passedAt = (0,utils_coverLetter/* getPassedAtText */.S)(coverLetter);
    var handleShareButtonClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var windoNavigator, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    windoNavigator = window.navigator;
                    if (!(windoNavigator && windoNavigator.share)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        windoNavigator.share({
                            title: quote,
                            url: "https://".concat(linkareer).concat(router.asPath)
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    setOpenShareModal(true);
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var handleSetCoverLetterId = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            createSelfIntroduction({
                                variables: {
                                    input: {
                                        title: "새 자기소개서",
                                        qnas: [
                                            {
                                                question: "",
                                                answer: "",
                                                charMaxSize: 1000
                                            }
                                        ]
                                    }
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        router.push({
                            pathname: "/self-introduction",
                            query: {
                                id: (ref1 = (ref = result.data) === null || ref === void 0 ? void 0 : ref.createSelfIntroduction.selfIntroduction) === null || ref1 === void 0 ? void 0 : ref1.id
                            }
                        });
                        setCoverLetterId("".concat(router.query.id));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetCoverLetterId() {
            return _ref.apply(this, arguments);
        };
    }();
    var search = (0,useSearchState/* useSearchStateContext */.az)().search;
    var highlightedOrgName = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName) || "-",
        keyword: search.organizationName
    });
    var highlightedRole = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role) || "-",
        keyword: search.role
    });
    var basicInfos = (0,arrayFilterJoin/* default */.Z)([
        highlightedOrgName,
        highlightedRole,
        passedAt, 
    ]);
    var quote = "".concat((0,arrayFilterJoin/* default */.Z)([
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName,
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role,
        passedAt, 
    ]), " 합격자소서 입니다");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverLetterDetailInfo_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "header-info",
                children: "합격 자소서"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "basic-info",
                dangerouslySetInnerHTML: {
                    __html: basicInfos
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "spec-info",
                children: (0,utils_coverLetter/* getSpecInfo */.t)(coverLetter)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "button-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "button-wrapper-inner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/self-introduction/manage",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cover-letter-write",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteCoverLetterIcon, {}),
                                            " 자소서 작성"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesktopTooltip, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterWriteTooltip, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cover-letter-write",
                                        onClick: handleSetCoverLetterId,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteCoverLetterIcon, {}),
                                            " 자소서 작성"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_ScrapButtonWithPopper, {
                                coverLetter: coverLetter,
                                currentUser: currentUser
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "cover-letter-share",
                                onClick: handleShareButtonClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShareText, {
                                        children: "공유하기"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "new-back-button-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_NewWindowAndBackButton, {
                            backButtonLink: listLink || "",
                            isSimplePage: isSimplePage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                quote: quote,
                url: "https://".concat(linkareer).concat(router.asPath),
                open: openShareModal,
                onModalClose: function() {
                    return setOpenShareModal(false);
                }
            })
        ]
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterDetailInfo = (CoverLetterDetailInfo);
var CoverLetterDetailInfo_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterDetailInfo__StyledWrapper",
    componentId: "sc-914fe02-0"
})(CoverLetterDetailInfo_templateObject(), media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm);
var StyledMobileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterDetailInfo__StyledMobileWrapper",
    componentId: "sc-914fe02-1"
})(CoverLetterDetailInfo_templateObject1(), media/* mobileBreakPoint */.vm);
var StyledDesktopTooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterDetailInfo__StyledDesktopTooltip",
    componentId: "sc-914fe02-2"
})(CoverLetterDetailInfo_templateObject2(), media/* mobileBreakPoint */.vm);
var StyledShareText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CoverLetterDetailInfo__StyledShareText",
    componentId: "sc-914fe02-3"
})(CoverLetterDetailInfo_templateObject3(), media/* mobileBreakPoint */.vm);
src_default()(CoverLetterDetailInfo_templateObject4());

// EXTERNAL MODULE: ./src/screens/CoverLetterItemScreen/constant.ts
var constant = __webpack_require__(48889);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterDetail.tsx

function CoverLetterDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterDetail_currentUser on User {\n    ...CoverLetterListItem_currentUser\n    ...CoverLetterDetailInfo_currentUser\n  }\n  fragment CoverLetterDetail_coverLetter on CoverLetter {\n    id\n    content\n    ...CoverLetterListItem_coverLetter\n    ...CoverLetterDetailInfo_coverLetter\n  }\n"
    ]);
    CoverLetterDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CoverLetterDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.scroll {\n    ",
        " {\n      max-width: 660px;\n      width: 100%;\n      flex: 1 1 0px;\n      overflow-y: auto;\n    }\n  }\n\n  > .root {\n    position: relative;\n    padding: 30px 20px 0 30px;\n    ",
        " {\n      background-color: #ffffff;\n      padding: 30px 20px 0 20px;\n      margin-bottom: 15px;\n    }\n  }\n\n  .selection-guide {\n    padding: 30px 20px 0 30px;\n    ",
        " {\n      padding: 0;\n    }\n  }\n\n  .container {\n    border-bottom: 1px solid #eee;\n    ",
        " {\n      border-bottom: none;\n    }\n  }\n\n  .content-wrapper {\n    padding: 30px 20px 30px 30px;\n    margin-bottom: 50px;\n    ",
        " {\n      padding: 20px 20px 30px 20px;\n      margin-top: 15px;\n      margin-bottom: 30px;\n      background-color: #ffffff;\n    }\n  }\n\n  .bottom-buttons-wrapper {\n    ",
        " {\n      padding-bottom: 50px;\n    }\n  }\n\n  .simple-page {\n    margin-bottom: 0;\n  }\n\n  .loading-container {\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    CoverLetterDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CoverLetterDetail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    CoverLetterDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





















var CoverLetterDetail_tabletBreakPoint = "@media (min-width: 960px)";
var CoverLetterDetail = function(param) {
    var _isSimplePage = param.isSimplePage, isSimplePage = _isSimplePage === void 0 ? false : _isSimplePage, listLink = param.listLink, coverLetter = param.coverLetter, currentUser = param.currentUser, onScrollEnter = param.onScrollEnter, onScrollLeave = param.onScrollLeave, onScrollTop = param.onScrollTop, onScrollMove = param.onScrollMove, highlight = param.highlight;
    var rootEl = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isScrollFull = ref[0], setIsScrollFull = ref[1];
    // tabletBreakPoint 이상인지 확인
    var isMdUp = (0,useMediaQuery/* default */.Z)("(min-width: 960px)");
    var coverLetterId = coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id;
    (0,react.useEffect)(function() {
        if (!coverLetterId || !isMdUp) {
            return;
        }
        if (rootEl.current) {
            if (rootEl.current.scrollTo) {
                rootEl.current.scrollTo({
                    left: 0,
                    top: 0,
                    behavior: "auto"
                });
            } else {
                rootEl.current.scrollTop = 0;
            }
        }
    }, [
        coverLetterId
    ]);
    var handleEnter = function(param) {
        var event = param.event;
        if (onScrollTop) {
            onScrollTop();
        }
        var target = get_default()(event, "target");
        if ((target === null || target === void 0 ? void 0 : target.scrollHeight) === (target === null || target === void 0 ? void 0 : target.offsetHeight)) {
            setIsScrollFull(true);
            return;
        }
        setIsScrollFull(false);
        if (onScrollEnter) {
            onScrollEnter();
        }
    };
    var handleLeave = function() {
        if (onScrollMove) {
            onScrollMove();
        }
        if (onScrollLeave) {
            onScrollLeave();
        }
    };
    var isComponentVisible = (0,useShowComponentByAppVersion/* default */.Z)(verifyAppVersionList/* VERIFIED_APP_VERSIONS.COVER_LETTER_AD_EDUCATION */.sJ.COVER_LETTER_AD_EDUCATION);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverLetterDetail_StyledWrapper, {
        className: !isSimplePage ? "scroll" : "",
        onWheel: isScrollFull ? undefined : function(event) {
            return event.stopPropagation();
        },
        ref: rootEl,
        children: [
            isMdUp && !isSimplePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Waypoint */.h, {
                onEnter: handleEnter,
                onLeave: handleLeave
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "root",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterDetailInfo, {
                        isSimplePage: isSimplePage,
                        listLink: listLink,
                        coverLetter: coverLetter !== null && coverLetter !== void 0 ? coverLetter : undefined,
                        currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "selection-guide",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterDetailContent_SelectionGuideBar, {
                    currentUser: currentUser
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper ".concat(isSimplePage ? "simple-page" : ""),
                children: [
                    isMdUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterSearchBannerStatus_desktop, {}) : isComponentVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterSearchBannerStatus_mobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        id: constant/* ARTICLE_ID_SELECTOR */.s,
                        onCopy: utils/* copySourceToClipboard */.b7,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterDetailContent_CoverLetterDetailContent, {
                            coverLetter: coverLetter,
                            highlight: highlight === null || highlight === void 0 ? void 0 : highlight[0],
                            currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bottom-buttons-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_NewWindowAndBackButton, {
                            backButtonLink: listLink || "",
                            isSimplePage: isSimplePage
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterDetail_HiddenSmDown, {
                        children: isSimplePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
var pickProps = pick_default()([
    "isSimplePage",
    "coverLetter",
    "currentUser",
    "listLink", 
]);
/* harmony default export */ var CoverLetterItemScreen_CoverLetterDetail = (/*#__PURE__*/(0,react.memo)(CoverLetterDetail, function(prevProps, nextProps) {
    return isEqual_default()(pickProps(prevProps), pickProps(nextProps));
}));
src_default()(CoverLetterDetail_templateObject());
var CoverLetterDetail_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterDetail__StyledWrapper",
    componentId: "sc-ec716c05-0"
})(CoverLetterDetail_templateObject1(), CoverLetterDetail_tabletBreakPoint, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, media/* mobileBreakPoint */.vm, CoverLetterDetail_tabletBreakPoint);
var CoverLetterDetail_HiddenSmDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterDetail__HiddenSmDown",
    componentId: "sc-ec716c05-1"
})(CoverLetterDetail_templateObject2(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterItemDesktopBody.tsx



function CoverLetterItemDesktopBody_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterItemDesktopBody_currentUser on User {\n    ...CoverLetterDetail_currentUser\n  }\n  fragment CoverLetterItemDesktopBody_coverLetter on CoverLetter {\n    ...CoverLetterDetail_coverLetter\n  }\n"
    ]);
    CoverLetterItemDesktopBody_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var SideBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5050).then(__webpack_require__.bind(__webpack_require__, 35050));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35050)
            ];
        }
    },
    ssr: false,
    loading: function SideBarLoading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
        });
    }
});
var useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        pcWrapper: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1
        },
        container: {
            display: "flex",
            minHeight: 0
        },
        simplePageContainer: {
            display: "block",
            flex: 1,
            minHeight: "initial"
        }
    };
});
var CoverLetterItemDesktopBody = function(param) {
    var isSimplePage = param.isSimplePage, coverLetter = param.coverLetter, currentUser = param.currentUser, listLink = param.listLink, highlight = param.highlight;
    var classes = useStyles();
    var ref = (0,react.useState)(false), disableWheel = ref[0], setDisableWheel = ref[1];
    var setShowHeader = (0,react.useContext)(PageLayout/* PageLayoutContext */.s).setShowHeader;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useDebouncedCallback/* default */.Z)(setShowHeader, 100, {
        maxWait: 200
    }), 1), debounceSetShowHeader = ref1[0];
    var onWheel = (0,react.useCallback)(function(event) {
        debounceSetShowHeader(event.deltaY < 0);
    }, []);
    var handleChildScrollEnter = (0,react.useCallback)(function() {
        setShowHeader(true);
    }, []);
    var handleChildScrollLeave = (0,react.useCallback)(function() {
        setShowHeader(false);
    }, []);
    var handleScrollTop = (0,react.useCallback)(function() {
        setDisableWheel(false);
    }, []);
    var handleScrollMove = (0,react.useCallback)(function() {
        setDisableWheel(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.pcWrapper,
        onWheel: disableWheel || isSimplePage ? undefined : onWheel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            className: (0,clsx_m/* default */.Z)(classes.container, (0,_define_property/* default */.Z)({}, classes.simplePageContainer, isSimplePage)),
            children: isSimplePage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterDetail, {
                isSimplePage: isSimplePage,
                coverLetter: coverLetter !== null && coverLetter !== void 0 ? coverLetter : undefined,
                currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined,
                highlight: highlight
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "440px",
                        display: "flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar, {
                            onScrollEnter: handleChildScrollEnter,
                            onScrollLeave: handleChildScrollLeave,
                            currentUser: currentUser
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterDetail, {
                        listLink: listLink,
                        coverLetter: coverLetter !== null && coverLetter !== void 0 ? coverLetter : undefined,
                        currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined,
                        onScrollEnter: handleChildScrollEnter,
                        onScrollLeave: handleChildScrollLeave,
                        onScrollTop: handleScrollTop,
                        onScrollMove: handleScrollMove,
                        highlight: highlight
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterItemDesktopBody = (CoverLetterItemDesktopBody);
src_default()(CoverLetterItemDesktopBody_templateObject());

// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var react_lazyload_lib = __webpack_require__(1216);
;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterItemMobileBody.tsx

function CoverLetterItemMobileBody_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterItemMobileBody_coverLetter on CoverLetter {\n    id\n    isScrapped\n    organizationName\n    role\n    ...CoverLetterUtils_getPassedAtText_coverLetter\n    ...CoverLetterDetail_coverLetter\n  }\n  fragment CoverLetterItemMobileBody_currentUser on User {\n    id\n    ...CoverLetterDetail_currentUser\n  }\n"
    ]);
    CoverLetterItemMobileBody_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CoverLetterItemMobileBody_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n"
    ]);
    CoverLetterItemMobileBody_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










src_default()(CoverLetterItemMobileBody_templateObject());
var CoverLetterItemMobileBody_SideBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5050).then(__webpack_require__.bind(__webpack_require__, 35050));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35050)
            ];
        }
    },
    ssr: false,
    loading: function SideBarLoading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 3,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
        });
    }
});
var getListLink = function(context) {
    var queryString = (0,CoverLetterListContent/* getQueryParams */.vl)(context);
    return "/cover-letter/search?".concat(queryString);
};
var CoverLetterItemMobileBody = function(param) {
    var coverLetter = param.coverLetter, currentUser = param.currentUser, highlight = param.highlight;
    var context = (0,useSearchState/* useSearchStateContext */.az)();
    var listLink = getListLink(context);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterDetail, {
                listLink: listLink,
                coverLetter: coverLetter !== null && coverLetter !== void 0 ? coverLetter : undefined,
                currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined,
                highlight: highlight
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_lazyload_lib/* default */.ZP, {
                once: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemMobileBody_SideBar, {
                    currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined
                })
            })
        ]
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterItemMobileBody = (CoverLetterItemMobileBody);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterItemMobileBody__Wrapper",
    componentId: "sc-db6dfaba-0"
})(CoverLetterItemMobileBody_templateObject1());

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-use/esm/usePrevious.js
var usePrevious = __webpack_require__(37176);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./src/components/custom-material-ui/TextField.tsx + 1 modules
var TextField = __webpack_require__(91661);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/desktop/components/SeachForm/RecommendKeyword.tsx
var RecommendKeyword = __webpack_require__(75548);
// EXTERNAL MODULE: ./src/screens/SearchScreen/useSearchState.ts
var SearchScreen_useSearchState = __webpack_require__(2974);
// EXTERNAL MODULE: ./src/svgIcons/Close.tsx
var Close = __webpack_require__(43785);
// EXTERNAL MODULE: ./src/svgIcons/ListBox.tsx
var ListBox = __webpack_require__(56933);
// EXTERNAL MODULE: ./src/utils/spamKeywordsUtils.ts
var spamKeywordsUtils = __webpack_require__(6120);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 6 modules
var Autocomplete = __webpack_require__(91458);
// EXTERNAL MODULE: ./src/app.feature/coverletter/modules/getCoverLetterTypeFromTab.ts
var getCoverLetterTypeFromTab = __webpack_require__(59976);
// EXTERNAL MODULE: ./src/svgIcons/Company.tsx
var Company = __webpack_require__(29530);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/SeachForm/Mui/OrganizationNameFieldDesktopMui.tsx





function OrganizationNameFieldDesktopMui_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n"
    ]);
    OrganizationNameFieldDesktopMui_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var OrganizationNameFieldDesktopMui_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        root: {
            width: "100%",
            minHeight: 50
        },
        textField: {
            marginRight: 5,
            flex: 1
        },
        fieldIcon: {
            marginLeft: 16,
            height: 16,
            width: 16,
            color: "#333333"
        },
        closeIcon: {
            width: 10,
            height: 10
        },
        autocompleteOption: {
            // nowarp for samsung/naver browser
            whiteSpace: "nowrap"
        }
    };
});
var OrganizationNameFieldDesktopMui = function(props) {
    var classes = OrganizationNameFieldDesktopMui_useStyles();
    var textFieldInputProps = props.InputProps, className = props.className;
    var tabState = (0,useSearchState/* useSearchStateContext */.az)().tabState;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, watch = ref.watch, setValue = ref.setValue, formState = ref.formState;
    var watchOrganizationName = watch("organizationName");
    var isSubmitting = formState.isSubmitting, touchedFields = formState.touchedFields;
    var orgTouched = touchedFields.organizationName;
    (0,react.useEffect)(function() {
        if (!orgTouched) {
            props.setShowAutoComplete("");
        }
    }, [
        orgTouched
    ]);
    var ref1 = (0,react.useState)(null), organizationList = ref1[0], setOrganizationList = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterScreen_SearchForm_CoverLetterOrganizationListLazyQuery */.wtL)(), 2), getOrganizationList = ref2[0], ref3 = ref2[1], organizationData = ref3.data, orgNameLoading = ref3.loading, refetch = ref3.refetch, called = ref3.called;
    var getOrganizationName = function(value) {
        if (called) {
            refetch({
                input: {
                    query: value,
                    status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                    types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                }
            });
        } else {
            getOrganizationList({
                variables: {
                    input: {
                        query: value,
                        status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                        types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                    }
                }
            });
        }
        props.setShowAutoComplete("organizationName");
    };
    var handleClearOrganizationNameField = function() {
        setValue("organizationName", "", {
            shouldDirty: true
        });
        props.setShowAutoComplete("");
    };
    // 자동완성 리스트
    (0,react.useEffect)(function() {
        if (organizationData === null || organizationData === void 0 ? void 0 : organizationData.coverLetterOrganizationList) {
            setOrganizationList(organizationData === null || organizationData === void 0 ? void 0 : organizationData.coverLetterOrganizationList);
        }
    }, [
        organizationData,
        organizationList
    ]);
    var handleChange = (0,react.useCallback)(function(e) {
        setValue("organizationName", e.target.value, {
            shouldDirty: true
        });
    }, [
        setValue
    ]);
    var handleOnChange = function(_e, value) {
        if (value) {
            setValue("organizationName", value.organizationName, {
                shouldDirty: true
            });
            props.setShowAutoComplete("");
        }
    };
    (0,react.useEffect)(function() {
        register("organizationName");
    }, [
        register
    ]);
    var autoCompleteClasses = {
        root: className,
        option: classes.autocompleteOption
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        open: props.showAutoComplete === "organizationName",
        onClose: function() {
            props.setShowAutoComplete("");
        },
        disabled: isSubmitting,
        id: "cover-letter-autocomplete-organization-name",
        getOptionLabel: function(org) {
            return org.organizationName;
        },
        options: organizationList || [],
        loading: orgNameLoading,
        classes: autoCompleteClasses,
        noOptionsText: "일치하는 기업이 없습니다.",
        loadingText: "불러오는중...",
        onChange: handleOnChange,
        inputValue: watchOrganizationName,
        filterOptions: function(options) {
            return options;
        },
        // TODO: Update MUI first
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderInput: function(_param) {
            var InputLabelProps = _param.InputLabelProps, params = (0,_object_without_properties/* default */.Z)(_param, [
                "InputLabelProps"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationNameFieldDesktopMui_StyledWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    onChange: handleChange,
                    fullWidth: true,
                    name: "organizationName",
                    type: "search",
                    className: classes.textField,
                    placeholder: "기업명",
                    onDebounceChange: getOrganizationName,
                    debounceDelayMS: orgTouched ? 500 : 0,
                    disabled: isSubmitting,
                    InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps, textFieldInputProps), {
                        inputProps: (0,_object_spread/* default */.Z)({}, params === null || params === void 0 ? void 0 : params.inputProps, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.inputProps),
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Company/* default */.Z, {
                                className: classes.fieldIcon
                            })
                        }),
                        endAdornment: watchOrganizationName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClearOrganizationNameField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                    className: classes.closeIcon
                                })
                            })
                        }) : null
                    })
                }))
            });
        }
    });
};
/* harmony default export */ var Mui_OrganizationNameFieldDesktopMui = (OrganizationNameFieldDesktopMui);
var OrganizationNameFieldDesktopMui_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrganizationNameFieldDesktopMui__StyledWrapper",
    componentId: "sc-99cc88f5-0"
})(OrganizationNameFieldDesktopMui_templateObject());

// EXTERNAL MODULE: ./src/svgIcons/Person.tsx
var Person = __webpack_require__(70080);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/SeachForm/Mui/RoleFieldDesktopMui.tsx





function RoleFieldDesktopMui_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n"
    ]);
    RoleFieldDesktopMui_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var RoleFieldDesktopMui_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        textField: {
            marginRight: 5,
            flex: 1
        },
        fieldIcon: {
            marginLeft: 16,
            height: 16,
            width: 16,
            color: "#333333"
        },
        closeIcon: {
            width: 10,
            height: 10
        },
        textFieldInput: {
            backgroundColor: "white"
        },
        autocompleteOption: {
            // nowarp for samsung/naver browser
            whiteSpace: "nowrap"
        }
    };
});
var RoleFieldDesktopMui = function(props) {
    var classes = RoleFieldDesktopMui_useStyles();
    var tabState = (0,useSearchState/* useSearchStateContext */.az)().tabState;
    var textFieldInputProps = props.InputProps, className = props.className;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, watch = ref.watch, setValue = ref.setValue, formState = ref.formState;
    var watchRole = watch("role");
    var isSubmitting = formState.isSubmitting, touchedFields = formState.touchedFields;
    var roleTouched = touchedFields.role;
    (0,react.useEffect)(function() {
        if (!roleTouched) {
            props.setShowAutoComplete("");
        }
    }, [
        roleTouched
    ]);
    var ref1 = (0,react.useState)(null), roleList = ref1[0], setRoleList = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterScreen_SearchForm_CoverLetterRoleListLazyQuery */.toi)(), 2), getRoleList = ref2[0], ref3 = ref2[1], roleData = ref3.data, roleLoading = ref3.loading, called = ref3.called, refetch = ref3.refetch;
    var getRole = function(value) {
        if (called) {
            refetch({
                input: {
                    query: value,
                    status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                    types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                }
            });
        } else {
            getRoleList({
                variables: {
                    input: {
                        query: value,
                        status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                        types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                    }
                }
            });
        }
        props.setShowAutoComplete("role");
    };
    var handleChange = (0,react.useCallback)(function(e) {
        setValue("role", e.target.value, {
            shouldDirty: true
        });
    }, [
        setValue
    ]);
    var handleOnChange = function(_e, value) {
        if (value) {
            setValue("role", value.role, {
                shouldDirty: true
            });
            props.setShowAutoComplete("");
        }
    };
    var handleClearRoleField = function() {
        setValue("role", "", {
            shouldDirty: true
        });
        props.setShowAutoComplete("");
    };
    (0,react.useEffect)(function() {
        register("role");
    }, [
        register
    ]);
    (0,react.useEffect)(function() {
        if (roleData === null || roleData === void 0 ? void 0 : roleData.coverLetterRoleList) {
            setRoleList(roleData === null || roleData === void 0 ? void 0 : roleData.coverLetterRoleList);
        }
    }, [
        roleData,
        roleList
    ]);
    var autoCompleteClasses = {
        root: className,
        option: classes.autocompleteOption
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        open: props.showAutoComplete === "role",
        onClose: function() {
            return props.setShowAutoComplete("");
        },
        disabled: isSubmitting,
        id: "cover-letter-autocomplete-role",
        getOptionLabel: function(role) {
            return role.role;
        },
        options: roleList || [],
        loading: roleLoading,
        classes: autoCompleteClasses,
        inputValue: watchRole,
        filterOptions: function(options) {
            return options;
        },
        noOptionsText: "일치하는 직무가 없습니다.",
        loadingText: "불러오는중...",
        onChange: handleOnChange,
        // TODO: Update MUI first
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderInput: function(_param) {
            var InputLabelProps = _param.InputLabelProps, params = (0,_object_without_properties/* default */.Z)(_param, [
                "InputLabelProps"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoleFieldDesktopMui_StyledWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    inputRef: register("role").ref,
                    onChange: handleChange,
                    fullWidth: true,
                    type: "search",
                    name: "role",
                    className: classes.textField,
                    placeholder: "직무",
                    onDebounceChange: getRole,
                    debounceDelayMS: roleTouched ? 500 : 0,
                    disabled: isSubmitting,
                    InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps, textFieldInputProps), {
                        inputProps: (0,_object_spread/* default */.Z)({}, params === null || params === void 0 ? void 0 : params.inputProps, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.inputProps),
                        classes: {
                            root: classes.textFieldInput
                        },
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {
                                className: classes.fieldIcon
                            })
                        }),
                        endAdornment: watchRole ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClearRoleField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                    className: classes.closeIcon
                                })
                            })
                        }) : null
                    })
                }))
            });
        }
    });
};
/* harmony default export */ var Mui_RoleFieldDesktopMui = (RoleFieldDesktopMui);
var RoleFieldDesktopMui_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RoleFieldDesktopMui__StyledWrapper",
    componentId: "sc-90b9dc4f-0"
})(RoleFieldDesktopMui_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/SeachForm/Mui/SearchFormDesktopMui.tsx



function SearchFormDesktopMui_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n"
    ]);
    SearchFormDesktopMui_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















var SearchFormDesktopMui_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            width: "100%",
            minHeight: 50
        },
        formWrapper: {
            maxWidth: 883,
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        textFieldWrapper: {
            width: "calc(100% - 88px)"
        },
        input: {
            fontWeight: 500,
            fontSize: 16,
            color: "#333",
            padding: "15.5px 3px",
            opacity: 1
        },
        searchButton: {
            backgroundColor: "#008bde",
            color: "white",
            width: 88,
            "&:hover": {
                backgroundColor: "#0082d0"
            }
        },
        fieldIcon: {
            marginLeft: 16,
            height: 16,
            width: 16,
            color: "#333333"
        },
        closeIcon: {
            width: 10,
            height: 10
        },
        textFieldInput: {
            backgroundColor: "white"
        },
        field: {
            width: 259,
            paddingRight: 5
        },
        dropdownBtn: {
            background: "none",
            border: "none",
            padding: "0px",
            display: "none",
            color: "#666666",
            fontSize: 12
        },
        organizationWrapper: {
            width: 259,
            display: "flex",
            alignItems: "stretch",
            gap: "4px"
        },
        organizationSubmitBtn: {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            height: 39,
            width: 80,
            padding: "auto",
            "&:hover": {
                backgroundColor: "#0082d0"
            }
        },
        expandMoreArrow: {
            width: 10,
            height: 10,
            marginLeft: 5
        },
        collapseArrow: {
            width: 10,
            height: 10,
            marginLeft: 5,
            marginTop: 15,
            transform: "scaleY(-1)"
        }
    };
});
var SearchFormDesktopMui = function(props) {
    var ref;
    var classes = SearchFormDesktopMui_useStyles();
    var router = (0,next_router.useRouter)();
    var coverLetterId = props.coverLetterId, submitButtonID = props.submitButtonID, _renderRecommendSearchKeyword = props.renderRecommendSearchKeyword, renderRecommendSearchKeyword = _renderRecommendSearchKeyword === void 0 ? true : _renderRecommendSearchKeyword, rootProps = props.rootProps, SubmitButtonProps = props.SubmitButtonProps, textFieldInputProps = props.InputProps;
    var ref1 = router === null || router === void 0 ? void 0 : router.query, _organizationName = ref1.organizationName, organizationName = _organizationName === void 0 ? "" : _organizationName, _role = ref1.role, role = _role === void 0 ? "" : _role, _keyword = ref1.keyword, keyword = _keyword === void 0 ? "" : _keyword;
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            organizationName: organizationName,
            role: role,
            keyword: keyword
        }
    });
    var watch = methods.watch, register = methods.register, handleSubmit = methods.handleSubmit, formState = methods.formState, setValue = methods.setValue, reset = methods.reset;
    var isSubmitting = formState.isSubmitting, isDirty = formState.isDirty;
    var watchKeyword = watch("keyword");
    var tabState = (0,SearchScreen_useSearchState/* useSearchStateContext */.az)().tabState;
    var prevTabState = (0,usePrevious/* default */.Z)(tabState);
    // 상세페이지인 경우 coverLetterId props 전달
    var ref2 = (0,react.useState)(null), dropdownOpened = ref2[0], setDropdownOpened = ref2[1];
    var ref3 = (0,react.useState)(""), showAutoComplete = ref3[0], setShowAutoComplete = ref3[1];
    (0,react.useEffect)(function() {
        setDropdownOpened(null);
    }, [
        coverLetterId
    ]);
    (0,react.useEffect)(function() {
        setValue("organizationName", organizationName);
    }, [
        organizationName
    ]);
    (0,react.useEffect)(function() {
        setValue("role", role);
    }, [
        role
    ]);
    (0,react.useEffect)(function() {
        setValue("keyword", keyword);
    }, [
        keyword
    ]);
    (0,react.useEffect)(function() {
        if (!prevTabState) {
            return;
        }
        if (prevTabState !== tabState) {
            reset({
                organizationName: "",
                role: "",
                keyword: ""
            });
        }
    }, [
        tabState
    ]);
    var onSubmit = function(param) {
        var organizationName = param.organizationName, role = param.role, keyword = param.keyword;
        if (!isDirty) {
            return;
        }
        var inputFields = [
            organizationName,
            role,
            keyword
        ];
        if ((0,spamKeywordsUtils/* isSpamSearchInput */.l)(inputFields)) {
            return;
        }
        setShowAutoComplete("");
        var nextQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            organizationName: organizationName || "",
            role: role || "",
            keyword: keyword || "",
            page: 1,
            sort: graphql/* CoverLetterOrderField.PASSED_AT */.lNF.PASSED_AT
        });
        var qs = "?".concat(query_string.stringify(nextQuery));
        router.push("/cover-letter/search".concat(qs), undefined, {
            shallow: true
        }).then(function() {
            reset({
                organizationName: organizationName,
                role: role,
                keyword: keyword
            }, {
                keepDirty: false
            });
        });
    };
    var handleDropdownBtnClick = function() {
        setDropdownOpened(!dropdownOpened);
    };
    var InputProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textFieldInputProps), {
        className: (0,clsx_m/* default */.Z)(classes.textFieldInput, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.className),
        inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.inputProps), {
            className: (0,clsx_m/* default */.Z)(classes.input, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : (ref = textFieldInputProps.inputProps) === null || ref === void 0 ? void 0 : ref.className)
        })
    });
    var registeredKeyword = register("keyword");
    var handleOnResetKeyword = function() {
        setValue("keyword", "", {
            shouldDirty: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, rootProps === null || rootProps === void 0 ? void 0 : rootProps.className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    className: classes.formWrapper,
                    autoComplete: "off",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.organizationWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Mui_OrganizationNameFieldDesktopMui, {
                                    className: classes.field,
                                    InputProps: InputProps,
                                    showAutoComplete: showAutoComplete,
                                    setShowAutoComplete: setShowAutoComplete
                                }),
                                dropdownOpened === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disableElevation: true,
                                    className: classes.organizationSubmitBtn,
                                    disabled: isSubmitting,
                                    variant: "contained",
                                    id: submitButtonID,
                                    children: "검색"
                                })
                            ]
                        }),
                        dropdownOpened !== false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Mui_RoleFieldDesktopMui, {
                                    className: classes.field,
                                    InputProps: InputProps,
                                    showAutoComplete: showAutoComplete,
                                    setShowAutoComplete: setShowAutoComplete
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchInput, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        inputRef: registeredKeyword.ref,
                                        fullWidth: true
                                    }, registeredKeyword), {
                                        className: classes.field,
                                        placeholder: "자소서 항목, 내용 등 키워드",
                                        type: "search",
                                        InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, InputProps), {
                                            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                position: "start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListBox/* default */.Z, {
                                                    className: classes.fieldIcon
                                                })
                                            }),
                                            endAdornment: watchKeyword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                position: "end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    onClick: handleOnResetKeyword,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                                        className: classes.closeIcon
                                                    })
                                                })
                                            }) : null
                                        })
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disableElevation: true,
                                    className: (0,clsx_m/* default */.Z)(classes.searchButton, SubmitButtonProps === null || SubmitButtonProps === void 0 ? void 0 : SubmitButtonProps.className),
                                    disabled: isSubmitting,
                                    variant: "contained",
                                    id: submitButtonID,
                                    children: "검색"
                                })
                            ]
                        }),
                        dropdownOpened !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: classes.dropdownBtn,
                            onClick: handleDropdownBtnClick,
                            children: [
                                "상세검색 ",
                                dropdownOpened === false && "펼치기",
                                dropdownOpened === true && "닫기",
                                dropdownOpened === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ExpandMore */.pb, {
                                    className: classes.collapseArrow
                                }),
                                dropdownOpened === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ExpandMore */.pb, {
                                    className: classes.expandMoreArrow
                                })
                            ]
                        })
                    ]
                }),
                renderRecommendSearchKeyword && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendKeyword/* default */.Z, {})
            ]
        }))
    });
};
/* harmony default export */ var Mui_SearchFormDesktopMui = (SearchFormDesktopMui);
var StyledSearchInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchFormDesktopMui__StyledSearchInput",
    componentId: "sc-f3f8920e-0"
})(SearchFormDesktopMui_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/SearchForm/Mui/OrganizationNameFieldMobileMui.tsx





function OrganizationNameFieldMobileMui_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n"
    ]);
    OrganizationNameFieldMobileMui_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var OrganizationNameFieldMobileMui_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        root: {
            width: "100%",
            minHeight: 50,
            marginTop: 10
        },
        textField: {
            marginRight: 5,
            flex: 1,
            marginBottom: 10
        },
        fieldIcon: {
            marginLeft: 16,
            height: 16,
            width: 16,
            color: "#333333"
        },
        autoCompletePaper: {
            border: "1px solid #ced4da"
        },
        closeIcon: {
            width: 10,
            height: 10
        },
        autocompleteOption: {
            // nowarp for samsung/naver browser
            whiteSpace: "nowrap"
        }
    };
});
var OrganizationNameFieldMobileMui = function(props) {
    var classes = OrganizationNameFieldMobileMui_useStyles();
    var textFieldInputProps = props.InputProps, className = props.className;
    var tabState = (0,useSearchState/* useSearchStateContext */.az)().tabState;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, watch = ref.watch, setValue = ref.setValue, formState = ref.formState;
    var watchOrganizationName = watch("organizationName");
    var isSubmitting = formState.isSubmitting, touchedFields = formState.touchedFields;
    var orgTouched = touchedFields.organizationName;
    (0,react.useEffect)(function() {
        if (!orgTouched) {
            props.setShowAutoComplete("");
        }
    }, [
        orgTouched
    ]);
    var ref1 = (0,react.useState)(null), organizationList = ref1[0], setOrganizationList = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterScreen_SearchForm_CoverLetterOrganizationListLazyQuery */.wtL)(), 2), getOrganizationList = ref2[0], ref3 = ref2[1], organizationData = ref3.data, orgNameLoading = ref3.loading, refetch = ref3.refetch, called = ref3.called;
    var getOrganizationName = function(value) {
        if (called) {
            refetch({
                input: {
                    query: value,
                    status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                    types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                }
            });
        } else {
            getOrganizationList({
                variables: {
                    input: {
                        query: value,
                        status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                        types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                    }
                }
            });
        }
        props.setShowAutoComplete("organizationName");
    };
    var handleClearOrganizationNameField = function() {
        setValue("organizationName", "", {
            shouldDirty: true
        });
        props.setShowAutoComplete("");
    };
    // 자동완성 리스트
    (0,react.useEffect)(function() {
        if (organizationData === null || organizationData === void 0 ? void 0 : organizationData.coverLetterOrganizationList) {
            setOrganizationList(organizationData === null || organizationData === void 0 ? void 0 : organizationData.coverLetterOrganizationList);
        }
    }, [
        organizationData,
        organizationList
    ]);
    var handleChange = (0,react.useCallback)(function(e) {
        setValue("organizationName", e.target.value, {
            shouldDirty: true
        });
    }, [
        setValue
    ]);
    var handleOnChange = function(_e, value) {
        if (value) {
            setValue("organizationName", value.organizationName, {
                shouldDirty: true
            });
            props.setShowAutoComplete("");
        }
    };
    (0,react.useEffect)(function() {
        register("organizationName");
    }, [
        register
    ]);
    var autoCompleteClasses = {
        root: className,
        paper: classes.autoCompletePaper,
        option: classes.autocompleteOption
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        open: props.showAutoComplete === "organizationName",
        onClose: function() {
            props.setShowAutoComplete("");
        },
        disabled: isSubmitting,
        id: "cover-letter-autocomplete-organization-name",
        getOptionLabel: function(org) {
            return org.organizationName;
        },
        options: organizationList || [],
        loading: orgNameLoading,
        classes: autoCompleteClasses,
        noOptionsText: "일치하는 기업이 없습니다.",
        loadingText: "불러오는중...",
        onChange: handleOnChange,
        inputValue: watchOrganizationName,
        filterOptions: function(options) {
            return options;
        },
        // TODO: Update MUI first
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderInput: function(_param) {
            var InputLabelProps = _param.InputLabelProps, params = (0,_object_without_properties/* default */.Z)(_param, [
                "InputLabelProps"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationNameFieldMobileMui_StyledWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    onChange: handleChange,
                    fullWidth: true,
                    name: "organizationName",
                    type: "search",
                    className: classes.textField,
                    placeholder: "기업명",
                    onDebounceChange: getOrganizationName,
                    debounceDelayMS: orgTouched ? 500 : 0,
                    disabled: isSubmitting,
                    InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps, textFieldInputProps), {
                        inputProps: (0,_object_spread/* default */.Z)({}, params === null || params === void 0 ? void 0 : params.inputProps, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.inputProps),
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Company/* default */.Z, {
                                className: classes.fieldIcon
                            })
                        }),
                        endAdornment: watchOrganizationName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClearOrganizationNameField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                    className: classes.closeIcon
                                })
                            })
                        }) : null
                    })
                }))
            });
        }
    });
};
/* harmony default export */ var Mui_OrganizationNameFieldMobileMui = (OrganizationNameFieldMobileMui);
var OrganizationNameFieldMobileMui_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrganizationNameFieldMobileMui__StyledWrapper",
    componentId: "sc-4e0535ca-0"
})(OrganizationNameFieldMobileMui_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/SearchForm/Mui/RoleFieldMobileMui.tsx





function RoleFieldMobileMui_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n"
    ]);
    RoleFieldMobileMui_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var RoleFieldMobileMui_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        textField: {
            marginRight: 5,
            flex: 1,
            marginBottom: 10
        },
        fieldIcon: {
            marginLeft: 16,
            height: 16,
            width: 16,
            color: "#333333"
        },
        autoCompletePaper: {
            border: "1px solid #ced4da"
        },
        closeIcon: {
            width: 10,
            height: 10
        },
        textFieldInput: {
            backgroundColor: "white"
        },
        autocompleteOption: {
            // nowarp for samsung/naver browser
            whiteSpace: "nowrap"
        }
    };
});
var RoleFieldMobileMui = function(props) {
    var classes = RoleFieldMobileMui_useStyles();
    var tabState = (0,useSearchState/* useSearchStateContext */.az)().tabState;
    var textFieldInputProps = props.InputProps, className = props.className;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, watch = ref.watch, setValue = ref.setValue, formState = ref.formState;
    var watchRole = watch("role");
    var isSubmitting = formState.isSubmitting, touchedFields = formState.touchedFields;
    var roleTouched = touchedFields.role;
    (0,react.useEffect)(function() {
        if (!roleTouched) {
            props.setShowAutoComplete("");
        }
    }, [
        roleTouched
    ]);
    var ref1 = (0,react.useState)(null), roleList = ref1[0], setRoleList = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterScreen_SearchForm_CoverLetterRoleListLazyQuery */.toi)(), 2), getRoleList = ref2[0], ref3 = ref2[1], roleData = ref3.data, roleLoading = ref3.loading, called = ref3.called, refetch = ref3.refetch;
    var getRole = function(value) {
        if (called) {
            refetch({
                input: {
                    query: value,
                    status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                    types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                }
            });
        } else {
            getRoleList({
                variables: {
                    input: {
                        query: value,
                        status: graphql/* CoverLetterStatus.PUBLISHED */.RGS.PUBLISHED,
                        types: (0,getCoverLetterTypeFromTab/* getCoverLetterTypeFromTab */.i)(tabState)
                    }
                }
            });
        }
        props.setShowAutoComplete("role");
    };
    var handleChange = (0,react.useCallback)(function(e) {
        setValue("role", e.target.value, {
            shouldDirty: true
        });
    }, [
        setValue
    ]);
    var handleOnChange = function(_e, value) {
        if (value) {
            setValue("role", value.role, {
                shouldDirty: true
            });
            props.setShowAutoComplete("");
        }
    };
    var handleClearRoleField = function() {
        setValue("role", "", {
            shouldDirty: true
        });
        props.setShowAutoComplete("");
    };
    (0,react.useEffect)(function() {
        register("role");
    }, [
        register
    ]);
    (0,react.useEffect)(function() {
        if (roleData === null || roleData === void 0 ? void 0 : roleData.coverLetterRoleList) {
            setRoleList(roleData === null || roleData === void 0 ? void 0 : roleData.coverLetterRoleList);
        }
    }, [
        roleData,
        roleList
    ]);
    var autoCompleteClasses = {
        root: className,
        paper: classes.autoCompletePaper,
        option: classes.autocompleteOption
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        open: props.showAutoComplete === "role",
        onClose: function() {
            return props.setShowAutoComplete("");
        },
        disabled: isSubmitting,
        id: "cover-letter-autocomplete-role",
        getOptionLabel: function(role) {
            return role.role;
        },
        options: roleList || [],
        loading: roleLoading,
        classes: autoCompleteClasses,
        inputValue: watchRole,
        filterOptions: function(options) {
            return options;
        },
        noOptionsText: "일치하는 직무가 없습니다.",
        loadingText: "불러오는중...",
        onChange: handleOnChange,
        // TODO: Update MUI first
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderInput: function(_param) {
            var InputLabelProps = _param.InputLabelProps, params = (0,_object_without_properties/* default */.Z)(_param, [
                "InputLabelProps"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoleFieldMobileMui_StyledWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    inputRef: register("role").ref,
                    onChange: handleChange,
                    fullWidth: true,
                    type: "search",
                    name: "role",
                    className: classes.textField,
                    placeholder: "직무",
                    onDebounceChange: getRole,
                    debounceDelayMS: roleTouched ? 500 : 0,
                    disabled: isSubmitting,
                    InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps, textFieldInputProps), {
                        inputProps: (0,_object_spread/* default */.Z)({}, params === null || params === void 0 ? void 0 : params.inputProps, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.inputProps),
                        classes: {
                            root: classes.textFieldInput
                        },
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {
                                className: classes.fieldIcon
                            })
                        }),
                        endAdornment: watchRole ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClearRoleField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                    className: classes.closeIcon
                                })
                            })
                        }) : null
                    })
                }))
            });
        }
    });
};
/* harmony default export */ var Mui_RoleFieldMobileMui = (RoleFieldMobileMui);
var RoleFieldMobileMui_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RoleFieldMobileMui__StyledWrapper",
    componentId: "sc-a3e29bce-0"
})(RoleFieldMobileMui_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/SearchForm/Mui/SearchFormMobileMui.tsx



function SearchFormMobileMui_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n    }\n  }\n  width: 100%;\n"
    ]);
    SearchFormMobileMui_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















var SearchFormMobileMui_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            width: "100%",
            marginTop: 10
        },
        formWrapper: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            maxWidth: 400,
            paddingLeft: 20,
            paddingRight: 20,
            gap: "5px",
            margin: "auto"
        },
        textFieldWrapper: {
            width: "100%"
        },
        input: {
            fontWeight: 500,
            fontSize: 16,
            color: "#333",
            opacity: 1,
            padding: "10.5px 3px"
        },
        searchButton: {
            color: "white",
            backgroundColor: theme.palette.primary.main,
            marginTop: "10px",
            width: "100%",
            "&:hover": {
                backgroundColor: "#0082d0"
            }
        },
        fieldIcon: {
            marginLeft: 16,
            height: 16,
            width: 16,
            color: "#333333"
        },
        closeIcon: {
            width: 10,
            height: 10
        },
        textFieldInput: {
            backgroundColor: "white"
        },
        field: {
            width: "100%",
            paddingRight: 0
        },
        dropdownBtn: {
            background: "none",
            border: "none",
            padding: "0px",
            color: "#666666",
            fontSize: 12,
            display: "block"
        },
        organizationWrapper: {
            display: "flex",
            alignItems: "stretch",
            gap: "4px",
            width: "100%"
        },
        organizationSubmitBtn: {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            height: 39,
            width: 80,
            padding: "auto",
            "&:hover": {
                backgroundColor: "#0082d0"
            }
        },
        expandMoreArrow: {
            width: 10,
            height: 10,
            marginLeft: 5
        },
        collapseArrow: {
            width: 10,
            height: 10,
            marginLeft: 5,
            marginTop: 15,
            transform: "scaleY(-1)"
        }
    };
});
var SearchFormMobileMui = function(props) {
    var ref;
    var classes = SearchFormMobileMui_useStyles();
    var router = (0,next_router.useRouter)();
    var coverLetterId = props.coverLetterId, submitButtonID = props.submitButtonID, rootProps = props.rootProps, SubmitButtonProps = props.SubmitButtonProps, textFieldInputProps = props.InputProps;
    var ref1 = router === null || router === void 0 ? void 0 : router.query, _organizationName = ref1.organizationName, organizationName = _organizationName === void 0 ? "" : _organizationName, _role = ref1.role, role = _role === void 0 ? "" : _role, _keyword = ref1.keyword, keyword = _keyword === void 0 ? "" : _keyword;
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            organizationName: organizationName,
            role: role,
            keyword: keyword
        }
    });
    var watch = methods.watch, register = methods.register, handleSubmit = methods.handleSubmit, formState = methods.formState, setValue = methods.setValue, reset = methods.reset;
    var isSubmitting = formState.isSubmitting, isDirty = formState.isDirty;
    var watchKeyword = watch("keyword");
    var tabState = (0,useSearchState/* useSearchStateContext */.az)().tabState;
    var prevTabState = (0,usePrevious/* default */.Z)(tabState);
    // 상세페이지인 경우 coverLetterId props 전달
    var ref2 = (0,react.useState)(coverLetterId ? false : null), dropdownOpened = ref2[0], setDropdownOpened = ref2[1];
    var ref3 = (0,react.useState)(""), showAutoComplete = ref3[0], setShowAutoComplete = ref3[1];
    (0,react.useEffect)(function() {
        setDropdownOpened(coverLetterId ? false : null);
    }, [
        coverLetterId
    ]);
    (0,react.useEffect)(function() {
        setValue("organizationName", organizationName);
    }, [
        organizationName
    ]);
    (0,react.useEffect)(function() {
        setValue("role", role);
    }, [
        role
    ]);
    (0,react.useEffect)(function() {
        setValue("keyword", keyword);
    }, [
        keyword
    ]);
    (0,react.useEffect)(function() {
        if (!prevTabState) {
            return;
        }
        if (prevTabState !== tabState) {
            reset({
                organizationName: "",
                role: "",
                keyword: ""
            });
        }
    }, [
        tabState
    ]);
    var onSubmit = function(param) {
        var organizationName = param.organizationName, role = param.role, keyword = param.keyword;
        if (!isDirty) {
            return;
        }
        var inputFields = [
            organizationName,
            role,
            keyword
        ];
        if ((0,spamKeywordsUtils/* isSpamSearchInput */.l)(inputFields)) {
            return;
        }
        setShowAutoComplete("");
        var nextQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            organizationName: organizationName || "",
            role: role || "",
            keyword: keyword || "",
            page: 1,
            sort: graphql/* CoverLetterOrderField.PASSED_AT */.lNF.PASSED_AT
        });
        var qs = "?".concat(query_string.stringify(nextQuery));
        router.push("/cover-letter/search".concat(qs), undefined, {
            shallow: true
        }).then(function() {
            reset({
                organizationName: organizationName,
                role: role,
                keyword: keyword
            }, {
                keepDirty: false
            });
        });
    };
    var handleDropdownBtnClick = function() {
        setDropdownOpened(!dropdownOpened);
    };
    var InputProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textFieldInputProps), {
        className: (0,clsx_m/* default */.Z)(classes.textFieldInput, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.className),
        inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : textFieldInputProps.inputProps), {
            className: (0,clsx_m/* default */.Z)(classes.input, textFieldInputProps === null || textFieldInputProps === void 0 ? void 0 : (ref = textFieldInputProps.inputProps) === null || ref === void 0 ? void 0 : ref.className)
        })
    });
    var registeredKeyword = register("keyword");
    var handleOnResetKeyword = function() {
        setValue("keyword", "", {
            shouldDirty: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, rootProps === null || rootProps === void 0 ? void 0 : rootProps.className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: classes.formWrapper,
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.organizationWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mui_OrganizationNameFieldMobileMui, {
                                className: classes.field,
                                InputProps: InputProps,
                                showAutoComplete: showAutoComplete,
                                setShowAutoComplete: setShowAutoComplete
                            }),
                            dropdownOpened === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                disableElevation: true,
                                className: classes.organizationSubmitBtn,
                                disabled: isSubmitting,
                                variant: "contained",
                                id: submitButtonID,
                                children: "검색"
                            })
                        ]
                    }),
                    dropdownOpened !== false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mui_RoleFieldMobileMui, {
                                className: classes.field,
                                InputProps: InputProps,
                                showAutoComplete: showAutoComplete,
                                setShowAutoComplete: setShowAutoComplete
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormMobileMui_StyledSearchInput, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    inputRef: registeredKeyword.ref,
                                    fullWidth: true
                                }, registeredKeyword), {
                                    className: classes.field,
                                    placeholder: "자소서 항목, 내용 등 키워드",
                                    type: "search",
                                    InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, InputProps), {
                                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "start",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListBox/* default */.Z, {
                                                className: classes.fieldIcon
                                            })
                                        }),
                                        endAdornment: watchKeyword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                onClick: handleOnResetKeyword,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                                    className: classes.closeIcon
                                                })
                                            })
                                        }) : null
                                    })
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                disableElevation: true,
                                className: (0,clsx_m/* default */.Z)(classes.searchButton, SubmitButtonProps === null || SubmitButtonProps === void 0 ? void 0 : SubmitButtonProps.className),
                                disabled: isSubmitting,
                                variant: "contained",
                                id: submitButtonID,
                                children: "검색"
                            })
                        ]
                    }),
                    dropdownOpened !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: classes.dropdownBtn,
                        onClick: handleDropdownBtnClick,
                        children: [
                            "상세검색 ",
                            dropdownOpened === false && "펼치기",
                            dropdownOpened === true && "닫기",
                            dropdownOpened === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ExpandMore */.pb, {
                                className: classes.collapseArrow
                            }),
                            dropdownOpened === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ExpandMore */.pb, {
                                className: classes.expandMoreArrow
                            })
                        ]
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ var Mui_SearchFormMobileMui = (SearchFormMobileMui);
var SearchFormMobileMui_StyledSearchInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchFormMobileMui__StyledSearchInput",
    componentId: "sc-109f9c83-0"
})(SearchFormMobileMui_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterItemSearchBox.tsx







var CoverLetterItemSearchBox_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: (0,_define_property/* default */.Z)({
            paddingTop: 10,
            paddingBottom: 10,
            width: "100%",
            backgroundColor: "#fafafa",
            borderBottom: "1px solid #bbbbbb",
            display: "flex",
            alignItems: "center",
            zIndex: 1
        }, theme.breakpoints.down("sm"), {
            position: "relative",
            marginBottom: 10,
            backgroundColor: "#fff",
            borderBottom: "1px solid #e8e8e8",
            zIndex: 0
        }),
        searchButton: (0,_define_property/* default */.Z)({
            backgroundColor: theme.palette.primary.main,
            paddingTop: 7.5,
            paddingBottom: 7.5,
            width: 62
        }, theme.breakpoints.down("sm"), {
            width: "calc(100% - 5px)"
        }),
        inputBorder: {
            border: "1px solid #ccc"
        },
        searchFormRoot: {
            margin: "0 auto",
            maxWidth: "883px",
            minHeight: "auto"
        },
        input: {
            paddingTop: 9,
            paddingBottom: 9
        }
    };
});
var CoverLetterItemSearchBox = function(param) {
    var coverLetterId = param.coverLetterId;
    var classes = CoverLetterItemSearchBox_useStyles();
    var rootRef = (0,react.useRef)(null);
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.root,
        ref: rootRef,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Mui_SearchFormMobileMui, {
            submitButtonID: "gtm-search2-button-coverletter",
            coverLetterId: coverLetterId,
            renderRecommendSearchKeyword: false,
            rootProps: {
                className: classes.searchFormRoot
            },
            SubmitButtonProps: {
                className: classes.searchButton
            },
            InputProps: {
                className: classes.inputBorder,
                inputProps: {
                    className: classes.input
                }
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Mui_SearchFormDesktopMui, {
            submitButtonID: "gtm-search2-button-coverletter",
            coverLetterId: coverLetterId,
            renderRecommendSearchKeyword: false,
            rootProps: {
                className: classes.searchFormRoot
            },
            SubmitButtonProps: {
                className: classes.searchButton
            },
            InputProps: {
                className: classes.inputBorder,
                inputProps: {
                    className: classes.input
                }
            }
        })
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterItemSearchBox = (/*#__PURE__*/(0,react.memo)(CoverLetterItemSearchBox, function(prevProps, nextProps) {
    return (prevProps === null || prevProps === void 0 ? void 0 : prevProps.coverLetterId) === (nextProps === null || nextProps === void 0 ? void 0 : nextProps.coverLetterId);
}));

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterItemMain.tsx


function CoverLetterItemMain_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterItemMain_currentUser on User {\n    ...CoverLetterItemDesktopBody_currentUser\n    ...CoverLetterItemMobileBody_currentUser\n  }\n  fragment CoverLetterItemMain_coverLetter on CoverLetter {\n    id\n    ...CoverLetterItemDesktopBody_coverLetter\n    ...CoverLetterItemMobileBody_coverLetter\n  }\n"
    ]);
    CoverLetterItemMain_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var CoverLetterItemMain_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: (0,_define_property/* default */.Z)({
            height: "100%",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column"
        }, theme.breakpoints.down("sm"), {
            backgroundColor: "#fafafa"
        })
    };
});
var CoverLetterItemMain_getListLink = function(context) {
    var queryString = (0,CoverLetterListContent/* getQueryParams */.vl)(context);
    return "/cover-letter/search?".concat(queryString);
};
var CoverLetterItemMain_tabletBreakPoint = "(min-width: 960px)";
var CoverLetterItemMain = function(param) {
    var coverLetter = param.coverLetter, currentUser = param.currentUser, highlight = param.highlight;
    var ref;
    var classes = CoverLetterItemMain_useStyles();
    var router = (0,next_router.useRouter)();
    var context = (0,useSearchState/* useSearchStateContext */.az)();
    var listLink = CoverLetterItemMain_getListLink(context);
    var isSimplePage = Boolean(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.simple);
    var isMobile = (0,src_context/* useUA */.nD)().isMobile;
    var isDesktop = (0,useMediaQuery/* default */.Z)(CoverLetterItemMain_tabletBreakPoint, {
        defaultMatches: isMobile ? false : true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterItemSearchBox, {
                coverLetterId: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id) || undefined
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterItemDesktopBody, {
                coverLetter: coverLetter !== null && coverLetter !== void 0 ? coverLetter : undefined,
                currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined,
                highlight: highlight,
                isSimplePage: isSimplePage,
                listLink: listLink,
                coverLetterId: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id) || undefined
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterItemMobileBody, {
                coverLetter: coverLetter !== null && coverLetter !== void 0 ? coverLetter : undefined,
                currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : undefined,
                highlight: highlight
            })
        ]
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterItemMain = (CoverLetterItemMain);
src_default()(CoverLetterItemMain_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/CoverLetterItemScreen.tsx


function CoverLetterItemScreen_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterItemScreen_currentUser on User {\n    id\n    ...CoverLetterItemMain_currentUser\n  }\n  fragment CoverLetterItemScreen_coverLetter on CoverLetter {\n    id\n    ...CoverLetterItemMain_coverLetter\n  }\n"
    ]);
    CoverLetterItemScreen_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var CoverLetterItemScreen_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        simplePageLayoutRoot: (0,_define_property/* default */.Z)({}, mediaQuery/* IE11 */.X, {
            overflowY: "auto"
        }),
        pageLayoutContainer: (0,_define_property/* default */.Z)({
            paddingTop: "60px",
            paddingBottom: 0,
            display: "flex",
            flexDirection: "column",
            flex: "1"
        }, theme.breakpoints.down("sm"), {
            paddingTop: 0
        }),
        footer: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("sm"), {
            paddingBottom: 60
        }),
        pageLoading: {
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center"
        }
    };
});
var CoverLetterItemScreen = function(param) {
    var currentUser = param.currentUser, coverLetter = param.coverLetter, highlight = param.highlight, searchState = param.searchState, onSearchStateChange = param.onSearchStateChange, renderComponents = param.renderComponents;
    var ref;
    var classes = CoverLetterItemScreen_useStyles();
    var router = (0,next_router.useRouter)();
    var isSimplePage = Boolean(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.simple);
    var pageLayoutRenderComponents = [
        "Header",
        "InternalNavBar",
        "MobileNavTab", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        classes: {
            root: (0,clsx_m/* default */.Z)((0,_define_property/* default */.Z)({}, classes.simplePageLayoutRoot, isSimplePage))
        },
        isNavBarSticky: true,
        renderComponents: renderComponents !== null && renderComponents !== void 0 ? renderComponents : pageLayoutRenderComponents,
        FooterProps: {
            className: classes.footer
        },
        ContainerProps: {
            className: classes.pageLayoutContainer,
            maxWidth: false,
            disableGutters: true
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useSearchState/* SearchStateContextProvider */.UK, {
            searchState: searchState,
            onSearchStateChange: onSearchStateChange,
            paginationMaxButtons: paginations/* MOBILE_BUTTON_SIZE */.zw,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterItemScreen_CoverLetterItemMain, {
                coverLetter: coverLetter,
                highlight: highlight,
                currentUser: currentUser
            })
        })
    });
};
/* harmony default export */ var CoverLetterItemScreen_CoverLetterItemScreen = (CoverLetterItemScreen);
src_default()(CoverLetterItemScreen_templateObject());

;// CONCATENATED MODULE: ./src/screens/CoverLetterItemScreen/index.ts

/* harmony default export */ var screens_CoverLetterItemScreen = (CoverLetterItemScreen_CoverLetterItemScreen);


/***/ }),

/***/ 66074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screens_ErrorScreen; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/components/PageLayout/index.tsx + 4 modules
var PageLayout = __webpack_require__(53949);
// EXTERNAL MODULE: ./src/components/index.ts + 2 modules
var components = __webpack_require__(94761);
// EXTERNAL MODULE: ./src/components/customer-message-form.tsx
var customer_message_form = __webpack_require__(6925);
;// CONCATENATED MODULE: ./src/screens/ErrorScreen/ErrorScreen.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgb(0, 0, 0, 0, 03);\n  padding-top: 80px;\n  padding-bottom: 200px;\n  margin: 0 auto;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 40px;\n  color: #f52020;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  color: rgb(0, 0, 0, 0.6);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 104px;\n  width: 328px;\n  margin: 0 auto;\n  text-align: center;\n\n  button {\n    height: 48px !important;\n    width: 328px !important;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n  border: 1px solid #00a0ff;\n  color: #01a0ff;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var ErrorContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorScreen__ErrorContent",
    componentId: "sc-559d0978-0"
})(_templateObject());
var ErrorTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ErrorScreen__ErrorTitle",
    componentId: "sc-559d0978-1"
})(_templateObject1());
var ErrorText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ErrorScreen__ErrorText",
    componentId: "sc-559d0978-2"
})(_templateObject2());
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorScreen__ButtonContainer",
    componentId: "sc-559d0978-3"
})(_templateObject3());
var QnAButton = (0,styled_components_browser_esm/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, (0,_object_spread/* default */.Z)({}, props));
}).withConfig({
    displayName: "ErrorScreen__QnAButton",
    componentId: "sc-559d0978-4"
})(_templateObject4());
var ErrorScreen = function(props) {
    var title = props.title, subTitle = props.subTitle;
    var openCustomerMessageForm = (0,customer_message_form/* useOpenCustomerMessageForm */.f)();
    var handlePrevButton = (0,react.useCallback)(function() {
        router_default().back();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorText, {
                        children: [
                            "Ooops!",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            subTitle
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                className: "is-primary is-fullwidth",
                                onClick: handlePrevButton,
                                children: "이전으로"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QnAButton, {
                                className: "is-fullwidth",
                                onClick: openCustomerMessageForm,
                                children: "고객문의하기"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ErrorScreen_ErrorScreen = (ErrorScreen);

;// CONCATENATED MODULE: ./src/screens/ErrorScreen/index.ts

/* harmony default export */ var screens_ErrorScreen = (ErrorScreen_ErrorScreen);


/***/ }),

/***/ 2974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lx": function() { return /* binding */ SearchOrderField; },
/* harmony export */   "UK": function() { return /* binding */ SearchStateContextProvider; },
/* harmony export */   "Xh": function() { return /* binding */ TabState; },
/* harmony export */   "az": function() { return /* binding */ useSearchStateContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8920);
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11521);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17563);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var constants_paginations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52169);
/* harmony import */ var hooks_usePagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27914);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55208);










var TabState;
(function(TabState) {
    TabState["All"] = "all";
    TabState["OpenActivity"] = "open-activity";
    TabState["Channel"] = "channel";
    TabState["NewsItem"] = "news-item";
    TabState["Community"] = "community";
    TabState["ClosedActivity"] = "closed-activity";
})(TabState || (TabState = {}));
var SearchOrderField;
(function(SearchOrderField) {
    SearchOrderField["ViewCount"] = "VIEW_COUNT";
    SearchOrderField["CreatedAt"] = "CREATED_AT";
    SearchOrderField["Relevance"] = "RELEVANCE";
})(SearchOrderField || (SearchOrderField = {}));
function initializeState(newState, updatedState) {
    if (!Object.keys(updatedState).includes("page")) {
        newState.page = 1;
        if (!Object.keys(updatedState).includes("sort")) {
            if (newState.tab === TabState.Community) {
                newState.sort = SearchOrderField.CreatedAt;
            } else {
                newState.sort = SearchOrderField.Relevance;
            }
        }
    }
    return newState;
}
function useSearchState(props) {
    var handleSearchStateChange = function handleSearchStateChange(updatedState) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, searchState, query_string__WEBPACK_IMPORTED_MODULE_0__.parse(window.location.search), updatedState);
        newState = initializeState(newState, updatedState);
        newState = (0,utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseValues */ .c6)(newState, {
            parseNumbers: true
        });
        if (onSearchStateChange) {
            onSearchStateChange(newState);
        }
    };
    var setOrderBy = function setOrderBy(orderField) {
        handleSearchStateChange({
            sort: orderField
        });
    };
    var setTabState = function setTabState(newTabState) {
        handleSearchStateChange({
            tab: newTabState
        });
    };
    var setActivePage = function setActivePage(newActivePage) {
        handleSearchStateChange({
            page: newActivePage
        });
    };
    var ref = props || {}, searchState = ref.searchState, onSearchStateChange = ref.onSearchStateChange;
    var theme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var isSMDown = (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
    var pagination = (0,hooks_usePagination__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        activePage: (searchState === null || searchState === void 0 ? void 0 : searchState.page) || 1,
        setActivePage: setActivePage,
        maxButtons: isSMDown ? constants_paginations__WEBPACK_IMPORTED_MODULE_7__/* .MOBILE_BUTTON_SIZE */ .zw : constants_paginations__WEBPACK_IMPORTED_MODULE_7__/* .PC_BUTTON_SIZE */ .lW
    });
    return {
        query: (searchState === null || searchState === void 0 ? void 0 : searchState.q) || "",
        tabState: (searchState === null || searchState === void 0 ? void 0 : searchState.tab) || TabState.All,
        setTabState: setTabState,
        page: (searchState === null || searchState === void 0 ? void 0 : searchState.page) || 1,
        pagination: pagination,
        orderBy: {
            orderField: (searchState === null || searchState === void 0 ? void 0 : searchState.sort) || SearchOrderField.Relevance,
            orderDirection: (searchState === null || searchState === void 0 ? void 0 : searchState.direction) || generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .OrderDirection.DESC */ .N9t.DESC
        },
        setOrderBy: setOrderBy
    };
}
var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,constate__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(useSearchState), 2);
var SearchStateContextProvider = ref[0], useSearchStateContext = ref[1];


/***/ }),

/***/ 93293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.$G; },
/* harmony export */   "$R": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.$R; },
/* harmony export */   "B1": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.B1; },
/* harmony export */   "DN": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.DN; },
/* harmony export */   "EN": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.EN; },
/* harmony export */   "FC": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.FC; },
/* harmony export */   "Op": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.Op; },
/* harmony export */   "P3": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.P3; },
/* harmony export */   "YR": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.YR; },
/* harmony export */   "aG": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.aG; },
/* harmony export */   "ai": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.ai; },
/* harmony export */   "b7": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.b7; },
/* harmony export */   "cK": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.cK; },
/* harmony export */   "cO": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.cO; },
/* harmony export */   "g2": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.g2; },
/* harmony export */   "iP": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.iP; },
/* harmony export */   "mR": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.mR; },
/* harmony export */   "nU": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.nU; },
/* harmony export */   "ob": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.ob; },
/* harmony export */   "pb": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.pb; },
/* harmony export */   "un": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.un; },
/* harmony export */   "w8": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.w8; },
/* harmony export */   "wb": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.wb; },
/* harmony export */   "x6": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.x6; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55208);



/***/ }),

/***/ 55208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ getCloseTagOf; },
/* harmony export */   "$R": function() { return /* binding */ formatDateYYYY_MM_DD; },
/* harmony export */   "B1": function() { return /* binding */ bfs; },
/* harmony export */   "DN": function() { return /* binding */ useFallbackImageInSSR; },
/* harmony export */   "EN": function() { return /* binding */ getStickyComponent; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "FC": function() { return /* binding */ jobTypeToString; },
/* harmony export */   "O9": function() { return /* binding */ birthdayValidation; },
/* harmony export */   "Op": function() { return /* binding */ getPeriodDate; },
/* harmony export */   "P3": function() { return /* binding */ getIsChannelUser; },
/* harmony export */   "YR": function() { return /* binding */ isTag; },
/* harmony export */   "aG": function() { return /* binding */ getRecruitScale; },
/* harmony export */   "ai": function() { return /* binding */ formatNumberComma; },
/* harmony export */   "b7": function() { return /* binding */ copySourceToClipboard; },
/* harmony export */   "c6": function() { return /* binding */ parseValues; },
/* harmony export */   "cK": function() { return /* binding */ getMobileSkickyHeights; },
/* harmony export */   "cO": function() { return /* binding */ formatBirthday; },
/* harmony export */   "fW": function() { return /* binding */ filterEmptyField; },
/* harmony export */   "g2": function() { return /* binding */ filterArrayEmpty; },
/* harmony export */   "iP": function() { return /* binding */ getComponentVisible; },
/* harmony export */   "mR": function() { return /* binding */ getSelectionText; },
/* harmony export */   "nU": function() { return /* binding */ getCurrentTab; },
/* harmony export */   "ob": function() { return /* binding */ getJobType; },
/* harmony export */   "pb": function() { return /* binding */ getValueFromActivityType; },
/* harmony export */   "un": function() { return /* binding */ formatPhoneNumber; },
/* harmony export */   "w8": function() { return /* binding */ formatDateYY_MM_DD; },
/* harmony export */   "wb": function() { return /* binding */ isValidTag; },
/* harmony export */   "x6": function() { return /* binding */ numberWithCommas; }
/* harmony export */ });
/* unused harmony export formatPeriodDate */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns_isValid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12274);
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23855);
/* harmony import */ var date_fns_subYears__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6758);
/* harmony import */ var lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29893);
/* harmony import */ var lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51584);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81763);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_overSome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87532);
/* harmony import */ var lodash_overSome__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_overSome__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16310);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47079);
/* harmony import */ var app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29012);
/* harmony import */ var constants_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42783);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35460);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15125);

















var formatPeriodDate = function(date) {
    if (!date) {
        return "";
    }
    var formattedDate = new Date(date);
    var yy = formattedDate.getFullYear() % 100;
    var mm = formattedDate.getMonth() + 1;
    var dd = formattedDate.getDate();
    return "".concat(yy, ".").concat(mm, ".").concat(dd);
};
var getPeriodDate = function(startAt, endAt) {
    if (!startAt && !endAt) {
        return "기간 없음";
    }
    return "".concat(formatPeriodDate(startAt), " ~ ").concat(formatPeriodDate(endAt));
};
var formatDateYY_MM_DD = function(date) {
    if (!date) {
        return "";
    }
    var formattedDate = new Date(date);
    var yy = formattedDate.getFullYear();
    var mm = formattedDate.getMonth() + 1;
    var dd = formattedDate.getDate();
    return "".concat(yy, ".").concat(mm, ".").concat(dd);
};
var formatDateYYYY_MM_DD = function(date) {
    if (!date) {
        return "";
    }
    var formattedDate = new Date(date);
    return formattedDate.toISOString().split("T")[0];
};
function useFallbackImageInSSR(fallbackSrc) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    /**
   * Error happened / catched after hydration
   */ var onError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.target.src = fallbackSrc;
    }, [
        fallbackSrc
    ]);
    /**
   * Error happened before hydration, but catched after hydration
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (ref && ref.current) {
            var _current = ref.current, complete = _current.complete, naturalHeight = _current.naturalHeight;
            var errorLoadingImgBeforeHydration = complete && naturalHeight === 0;
            if (errorLoadingImgBeforeHydration) {
                ref.current.src = fallbackSrc;
            }
        }
    }, [
        fallbackSrc
    ]);
    return {
        ref: ref,
        onError: onError
    };
}
var shortenText = function(text, length) {
    if (text.length > length) {
        return "".concat(text.substr(0, length), "...");
    }
    return text;
};
var jobTypeToString = function(jobType) {
    switch(jobType){
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.NEW */ .O4l.NEW:
            {
                return "신입";
            }
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.INTERN */ .O4l.INTERN:
            {
                return "인턴";
            }
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED:
            {
                return "경력직";
            }
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.CONTRACT */ .O4l.CONTRACT:
            {
                return "계약직";
            }
        default:
            {
                throw new Error("job type is not valid.");
            }
    }
};
var getJobType = function(jobTypes) {
    var jobs = jobTypes.map(function(jobType) {
        return jobTypeToString(jobType);
    });
    return jobs === null || jobs === void 0 ? void 0 : jobs.join(", ");
};
var getRecruitScale = function(recruitScale) {
    switch(recruitScale){
        case undefined:
        case null:
        case constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .RecruitScaleType.ONE_DIGIT */ .aP.ONE_DIGIT:
            {
                return "0명";
            }
        case constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .RecruitScaleType.TEN_DIGIT */ .aP.TEN_DIGIT:
            {
                return "00명";
            }
        case constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .RecruitScaleType.HUNDRED_DIGIT */ .aP.HUNDRED_DIGIT:
            {
                return "000명";
            }
        default:
            {
                return "".concat(recruitScale, "명");
            }
    }
};
var getValueFromActivityType = function(activityTypeID, values) {
    var _obj;
    var navigate = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, values.activity), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, values.contest), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CLUB */ .kF.CLUB, values.club), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.INTERN */ .kF.INTERN, values.intern), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, values.recruit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, values.education), _obj);
    if (!activityTypeID) {
        throw new Error("Activity type is not valid.");
    }
    return navigate[activityTypeID];
};
var formatPhoneNumber = function(phoneNumber) {
    var matched = phoneNumber.match(/^(010)(\d{4})(\d{4})$/);
    if (matched) {
        return matched[1] + "-" + matched[2] + "-" + matched[3];
    }
};
var filterEmpty = function(value) {
    if (!lodash_isNumber__WEBPACK_IMPORTED_MODULE_5___default()(value) && !lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2___default()(value)) {
        return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(value);
    }
    return false;
};
var filterEmptyField = lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1___default()(lodash_overSome__WEBPACK_IMPORTED_MODULE_6___default()([
    (lodash_isNil__WEBPACK_IMPORTED_MODULE_4___default()),
    filterEmpty
]));
var filterArrayEmpty = function(arr) {
    var filterArray = lodash_overSome__WEBPACK_IMPORTED_MODULE_6___default()([
        (lodash_isNil__WEBPACK_IMPORTED_MODULE_4___default()),
        filterEmpty
    ]);
    var filteredArray = arr.filter(function(it) {
        return !filterArray(it);
    });
    return filteredArray;
};
// https://github.com/sindresorhus/query-string/blob/7712622f5ae8cc1f99ae45f4af1a1965efec44ac/index.js
var parseValues = function(values, options) {
    if (!options) return values;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            var value = values[k];
            if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
                value = Number(value);
            } else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
                value = value.toLowerCase() === "true";
            }
            values[k] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return values;
};
var bfs = function(root, childProp, visit, depth) {
    var q = [];
    var node;
    var currDepth = 0;
    q.push(root);
    q.push(null);
    while(q.length !== 0){
        node = q.shift();
        if (!node) {
            currDepth += 1;
            q.push(null);
            if (!q[0]) break;
            continue;
        }
        if (depth !== 0 && !depth) {
            visit(node);
        } else {
            currDepth === depth && visit(node);
        }
        var children = node[childProp];
        for(var i = 0; i < (children === null || children === void 0 ? void 0 : children.length); i += 1){
            q.push(children[i]);
        }
    }
};
var copySourceToClipboard = function(event) {
    var ref;
    event.stopPropagation();
    event.preventDefault();
    var span = document.createElement("SPAN");
    var content = (ref = window.getSelection()) === null || ref === void 0 ? void 0 : ref.getRangeAt(0).cloneContents();
    if (content) {
        span.appendChild(content);
        event.clipboardData.setData("Text", span.textContent + "\n\n" + _config__WEBPACK_IMPORTED_MODULE_11__/* .COPY_SUFFIX */ .jk) // ie
        ;
        event.clipboardData.setData("text/html", span.innerHTML + "<br /><br />" + _config__WEBPACK_IMPORTED_MODULE_11__/* .COPY_SUFFIX */ .jk);
        event.clipboardData.setData("text/plain", span.textContent + "\n\n" + _config__WEBPACK_IMPORTED_MODULE_11__/* .COPY_SUFFIX */ .jk);
    }
};
function numberWithCommas(count) {
    return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
var NATIVE_TAGS = [
    "address",
    "article",
    "aside",
    "blockquote",
    "details",
    "dialog",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "li",
    "main",
    "nav",
    "ol",
    "p",
    "pre",
    "section",
    "table",
    "ul",
    "a",
    "abbr",
    "acronym",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "br",
    "button",
    "canvas",
    "cite",
    "code",
    "data",
    "datalist",
    "del",
    "dfn",
    "em",
    "embed",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "map",
    "mark",
    "meter",
    "noscript",
    "object",
    "output",
    "picture",
    "progress",
    "q",
    "ruby",
    "s",
    "samp",
    "script",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "svg",
    "template",
    "textarea",
    "time",
    "u",
    "tt",
    "var",
    "video",
    "wbr", 
];
function isValidTag(tagName) {
    return NATIVE_TAGS.includes(tagName);
}
function isTag(tag) {
    return /(<([^>]+)>)/gi.test(tag);
}
function getCloseTagOf(tag) {
    if (tag.charAt(1) === "/") {
        return tag;
    }
    return "".concat(tag.substring(0, 1), "/").concat(tag.substring(1, tag.length));
}
function getSelectionText() {
    if (constants_common__WEBPACK_IMPORTED_MODULE_13__/* .IS_SERVER */ .W) {
        return "";
    }
    var selection = window.getSelection();
    if (!selection) {
        return "";
    }
    return selection === null || selection === void 0 ? void 0 : selection.toString();
}
var formatBirthday = function(birthday) {
    // 숫자만 추출하고 8자리로 제한
    var originNumber = birthday.replace(/[^0-9]/g, "").slice(0, 8);
    if (originNumber.length <= 4) {
        return originNumber;
    }
    if (originNumber.length <= 6) {
        return originNumber.replace(/(\d{4})(\d{1,2})/, "$1-$2");
    }
    return originNumber.replace(/(\d{4})(\d{2})(\d{0,2})/, "$1-$2-$3");
};
/**
 * 생년월일 validation을 위한 yup schema 생성 함수
 * @param format - 날짜 형식 ('YYYY-MM-DD' | 'YYYYMMDD')
 * @returns yup string schema
 */ var birthdayValidation = function(format) {
    var config = {
        "YYYY-MM-DD": {
            pattern: /^[0-9-]+$/,
            length: 10,
            getLengthToCheck: function(birthday) {
                return birthday.length;
            }
        },
        YYYYMMDD: {
            pattern: /^[0-9.]+$/,
            length: 8,
            getLengthToCheck: function(birthday) {
                return birthday.replace(/[^0-9]/g, "").length;
            }
        }
    };
    var _format = config[format], pattern = _format.pattern, length = _format.length, getLengthToCheck = _format.getLengthToCheck;
    return yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().test({
        name: "is-only-number",
        test: function(birthday) {
            var result = !birthday || pattern.test(birthday);
            return result;
        },
        message: "생년월일 형식이 올바르지 않습니다"
    }).test({
        name: "is-valid-date",
        test: function(birthday) {
            if (!birthday) {
                return true;
            }
            var birthdayISO = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(birthday);
            var lengthToCheck = getLengthToCheck(birthday);
            var isValidated = lengthToCheck === length && (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(birthdayISO);
            var minimumYear = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("1900-01-01");
            var isAfter1900 = birthdayISO >= minimumYear;
            var isFuture = birthdayISO > new Date();
            return isValidated && isAfter1900 && !isFuture;
        },
        message: "생년월일 형식이 올바르지 않습니다"
    }).test({
        name: "is-over-15",
        test: function(birthday) {
            if (!birthday) {
                return true;
            }
            var birthdayISO = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(birthday);
            var minimumDate = (0,date_fns_subYears__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(new Date(), 15);
            var isValidDate = (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(birthdayISO);
            var result = isValidDate && birthdayISO <= minimumDate;
            return result;
        },
        message: "만 15세 미만은 이용할 수 없습니다"
    }).required("생년월일을 입력해주세요");
};
var formatNumberComma = function(count) {
    return new Intl.NumberFormat("ko-KR").format(count);
};
var getMobileSkickyHeights = function(mobileStickyComponents) {
    var mobileHeightList = [
        {
            component: "Header",
            height: 50
        },
        {
            component: "MobileSearchBar",
            height: 60
        },
        {
            component: "MobileNavTab",
            height: 50
        }, 
    ];
    var heightMap = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mobileStickyComponents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var targetComponent = _step.value;
            var height = 0;
            for(var index = 0; index < mobileHeightList.length && mobileHeightList[index].component !== targetComponent; index++){
                var _index = mobileHeightList[index], component = _index.component, componentHeight = _index.height;
                if (mobileStickyComponents.includes(component)) {
                    height += componentHeight;
                }
            }
            heightMap[targetComponent] = height;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return heightMap;
};
var getComponentVisible = function(renderComponents) {
    var componentVisible = {
        ExternalNavBar: false,
        Header: false,
        SearchBar: false,
        InternalNavBar: false,
        MobileSearchBar: false,
        MobileNavTab: false,
        Footer: false
    };
    renderComponents.forEach(function(component) {
        componentVisible[component] = true;
    });
    return componentVisible;
};
var getStickyComponent = function(mobileStickyComponents) {
    var isStickyComponent = {
        Header: false,
        MobileSearchBar: false,
        MobileNavTab: false
    };
    mobileStickyComponents.forEach(function(component) {
        isStickyComponent[component] = true;
    });
    return isStickyComponent;
};
var getCurrentTab = function(pathname, query, activity) {
    if (pathname === "/") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ROOT */ .Ld.ROOT;
    if (pathname.match(/^\/channel.*/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CHANNEL */ .Ld.CHANNEL;
    if (pathname.match(/^\/calendar.*/)) {
        if (query.parentActiveTab === "activity") {
            return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CALENDAR_ACTIVITY */ .Ld.CALENDAR_ACTIVITY;
        }
        return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CALENDAR_RECRUIT */ .Ld.CALENDAR_RECRUIT;
    }
    if (pathname.match(/^\/cover-letter.*/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.COVER_LETTER */ .Ld.COVER_LETTER;
    if (pathname.match(/^\/self-introduction.*/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.SELF_INTRODUCTION */ .Ld.SELF_INTRODUCTION;
    if (pathname === "/list/intern") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.INTERN */ .Ld.INTERN;
    if (pathname === "/list/recruit") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.RECRUIT */ .Ld.RECRUIT;
    if (pathname === "/list/activity") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ACTIVITY */ .Ld.ACTIVITY;
    if (pathname === "/list/contest") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CONTEST */ .Ld.CONTEST;
    if (pathname === "/list/club") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CLUB */ .Ld.CLUB;
    if (pathname === "/list/education") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.EDUCATION */ .Ld.EDUCATION;
    if (pathname.match(/^\/team($|\/)/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.TEAM_RECRUIT */ .Ld.TEAM_RECRUIT;
    if (pathname.match(/^\/activity.*/)) {
        var ref;
        var isIntern = activity === null || activity === void 0 ? void 0 : (ref = activity.jobTypes) === null || ref === void 0 ? void 0 : ref.includes(generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.INTERN */ .O4l.INTERN);
        if (isIntern && (activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.INTERN */ .Ld.INTERN;
        if (!isIntern && (activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.RECRUIT */ .Ld.RECRUIT;
        if ((activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ACTIVITY */ .Ld.ACTIVITY;
        if ((activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CONTEST */ .kF.CONTEST) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CONTEST */ .Ld.CONTEST;
        if ((activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CLUB */ .kF.CLUB) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CLUB */ .Ld.CLUB;
    }
    return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ROOT */ .Ld.ROOT;
};
var getIsChannelUser = function(currentUser) {
    return currentUser && currentUser.type !== generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .UserType.NORMAL */ .FWD.NORMAL;
};


/***/ })

}]);